import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type CreateMyEngineSettingsInput = {
  json: Scalars['String']['input'];
  name: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type Credential = NetSuiteCredentials | NetSuiteOAuth2Credentials;

export type CredentialInput = {
  netsuiteCredentials?: InputMaybe<NetSuiteCredentialsInput>;
  netsuiteOAuth2Credentials?: InputMaybe<NetSuiteOAuth2CredentialsInput>;
};

export type Customer = {
  __typename?: 'Customer';
  defaultRole?: Maybe<Scalars['String']['output']>;
  emailDomains?: Maybe<Array<Scalars['String']['output']>>;
  features?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CustomerWithFeatureFlags = {
  __typename?: 'CustomerWithFeatureFlags';
  features?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EngineSettings = {
  __typename?: 'EngineSettings';
  default: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  json?: Maybe<Scalars['String']['output']>;
  layer?: Maybe<Layer>;
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum FeatureFlagAccessLevel {
  Admin = 'ADMIN',
  Root = 'ROOT'
}

export enum FeatureFlagName {
  AvantiCardRuns = 'AvantiCardRuns',
  ForecastTracking = 'ForecastTracking',
  Inventory = 'Inventory',
  InventoryHealth = 'InventoryHealth',
  InventoryHealthWithTransfers = 'InventoryHealthWithTransfers',
  Mrp = 'MRP',
  MyTeam = 'MyTeam',
  PoExportDefault = 'POExportDefault',
  PoExportWithAtomicMaster = 'POExportWithAtomicMaster',
  PoInbox = 'POInbox',
  PurchasingCalendar = 'PurchasingCalendar',
  RawInventoryHealth = 'RawInventoryHealth',
  SkuCutovers = 'SkuCutovers',
  SupplyWalkEdit = 'SupplyWalkEdit',
  TransferPlanning = 'TransferPlanning',
  TransferRecommendations = 'TransferRecommendations'
}

export type FeatureFlagsInput = {
  customerId: Scalars['String']['input'];
  features: Scalars['String']['input'];
};

export type Layer = {
  __typename?: 'Layer';
  id: Scalars['String']['output'];
  rows: Array<LayerRow>;
};

export type LayerChangeSetInput = {
  adjustmentId: Scalars['String']['input'];
  adjustmentLevel: Scalars['String']['input'];
  createdAt: Scalars['String']['input'];
  operation: Scalars['String']['input'];
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type LayerRow = {
  __typename?: 'LayerRow';
  adjustmentId: Scalars['String']['output'];
  adjustmentLevel: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  periodEnd?: Maybe<Scalars['String']['output']>;
  periodStart: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelMyRun?: Maybe<Scalars['String']['output']>;
  copyForecastToDefaultSettings?: Maybe<MyCustomer>;
  createCustomer?: Maybe<Customer>;
  createCustomerEmailDomain?: Maybe<Customer>;
  createMyEmailDomain?: Maybe<Customer>;
  createMyEngineSettings?: Maybe<EngineSettings>;
  createOrReplaceFeatureFlags?: Maybe<Scalars['String']['output']>;
  deleteCustomerEmailDomain?: Maybe<Customer>;
  deleteMyEmailDomain?: Maybe<Customer>;
  executeMyLayerChangeSet?: Maybe<Layer>;
  inviteMyTeamMember?: Maybe<User>;
  makeMyEngineSettingsDefault?: Maybe<MyCustomer>;
  removeMyTeamMember?: Maybe<User>;
  rerunMyStep?: Maybe<Scalars['String']['output']>;
  retryMyRun?: Maybe<Scalars['String']['output']>;
  saveApprovedPOs?: Maybe<Scalars['String']['output']>;
  saveApprovedPOsBatch?: Maybe<SaveApprovedPOsBatchResult>;
  saveMyValidationSettings?: Maybe<ValidationSettings>;
  savePurchasingCalendarOverrideToDefaultSettings?: Maybe<MyCustomer>;
  setMyCredentials?: Maybe<Scalars['String']['output']>;
  setMyRunDescription?: Maybe<Scalars['String']['output']>;
  setMyRunName?: Maybe<Scalars['String']['output']>;
  setMyTeamMemberTemporaryPassword?: Maybe<User>;
  startMyRecalculatedUserRun?: Maybe<Run>;
  startMyRun?: Maybe<Run>;
  startMySheetImporterSync?: Maybe<Scalars['String']['output']>;
  startMyUserRun?: Maybe<Run>;
  storeMyEditedLayerAsSettings?: Maybe<EngineSettings>;
  storeMyPullSourceConfig?: Maybe<Scalars['String']['output']>;
  storeMyViewForPreload?: Maybe<MyCustomer>;
  triggerMyPullWorkflow?: Maybe<Scalars['String']['output']>;
  triggerMyRunNextSteps?: Maybe<Scalars['String']['output']>;
  unlockForecastFromDefaultSettings?: Maybe<MyCustomer>;
  uploadFinalLayerAndStartMyRun: ParquetUploadResult;
};


export type MutationCancelMyRunArgs = {
  runSettings: RunInput;
};


export type MutationCopyForecastToDefaultSettingsArgs = {
  sourceInputId: Scalars['String']['input'];
  sourceRunId: Scalars['String']['input'];
  sourceSettingsNameAndVersion: Scalars['String']['input'];
};


export type MutationCreateCustomerArgs = {
  defaultRole: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateCustomerEmailDomainArgs = {
  customerId: Scalars['String']['input'];
  emailDomain: Scalars['String']['input'];
};


export type MutationCreateMyEmailDomainArgs = {
  emailDomain: Scalars['String']['input'];
};


export type MutationCreateMyEngineSettingsArgs = {
  engineSettings: CreateMyEngineSettingsInput;
};


export type MutationCreateOrReplaceFeatureFlagsArgs = {
  featureFlags: FeatureFlagsInput;
};


export type MutationDeleteCustomerEmailDomainArgs = {
  customerId: Scalars['String']['input'];
  emailDomain: Scalars['String']['input'];
};


export type MutationDeleteMyEmailDomainArgs = {
  emailDomain: Scalars['String']['input'];
};


export type MutationExecuteMyLayerChangeSetArgs = {
  layerChangeSet: LayerChangeSetInput;
  layerId: Scalars['String']['input'];
};


export type MutationInviteMyTeamMemberArgs = {
  email: Scalars['String']['input'];
  temporaryPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMakeMyEngineSettingsDefaultArgs = {
  settingsName: Scalars['String']['input'];
  settingsVersion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveMyTeamMemberArgs = {
  email: Scalars['String']['input'];
};


export type MutationRerunMyStepArgs = {
  runSettings: MyRunSettingsInput;
  stepId: Scalars['String']['input'];
};


export type MutationRetryMyRunArgs = {
  runSettings: RunInput;
};


export type MutationSaveApprovedPOsArgs = {
  poAction: PoActionInput;
  runSettings: MyRunSettingsInput;
};


export type MutationSaveApprovedPOsBatchArgs = {
  actions: Array<PoActionInput>;
  runSettings: MyRunSettingsInput;
};


export type MutationSaveMyValidationSettingsArgs = {
  input: SaveMyValidationSettingsInput;
};


export type MutationSavePurchasingCalendarOverrideToDefaultSettingsArgs = {
  fileContent: Scalars['String']['input'];
  runSettings?: InputMaybe<UserRunSettingsInput>;
};


export type MutationSetMyCredentialsArgs = {
  credentialsJson: Scalars['String']['input'];
};


export type MutationSetMyRunDescriptionArgs = {
  description: Scalars['String']['input'];
  runSettings: MyRunSettingsInput;
};


export type MutationSetMyRunNameArgs = {
  name: Scalars['String']['input'];
  runSettings: MyRunSettingsInput;
};


export type MutationSetMyTeamMemberTemporaryPasswordArgs = {
  email: Scalars['String']['input'];
  temporaryPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartMyRecalculatedUserRunArgs = {
  runSettings: UserRunSettingsInput;
};


export type MutationStartMyRunArgs = {
  runSettings: MyRunSettingsInput;
};


export type MutationStartMyUserRunArgs = {
  runSettings: UserRunSettingsInput;
};


export type MutationStoreMyEditedLayerAsSettingsArgs = {
  layerId: Scalars['String']['input'];
  settingsName: Scalars['String']['input'];
  settingsVersion: Scalars['String']['input'];
};


export type MutationStoreMyPullSourceConfigArgs = {
  configJson: Scalars['String']['input'];
};


export type MutationStoreMyViewForPreloadArgs = {
  datasetName: Scalars['String']['input'];
  deletePinName?: InputMaybe<Scalars['String']['input']>;
  oldPinName?: InputMaybe<Scalars['String']['input']>;
  paramsJSON: Scalars['String']['input'];
  pinName?: InputMaybe<Scalars['String']['input']>;
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  transformId: Scalars['String']['input'];
};


export type MutationTriggerMyRunNextStepsArgs = {
  runSettings: RunInput;
};


export type MutationUploadFinalLayerAndStartMyRunArgs = {
  editedRunSettings: MyRunSettingsInput;
  fileContent: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  runName?: InputMaybe<Scalars['String']['input']>;
};

export type MyCustomer = {
  __typename?: 'MyCustomer';
  defaultEngineSettingName?: Maybe<Scalars['String']['output']>;
  defaultEngineSettingVersion?: Maybe<Scalars['String']['output']>;
  ej2License?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Scalars['String']['output']>;
  forecastLockedToRunId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  muiLicense?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  preloadDatasets?: Maybe<Array<PreloadDataset>>;
};

export type MyRunSettingsInput = {
  inputId: Scalars['String']['input'];
  runAttemptId: Scalars['String']['input'];
  settingsNameAndVersion: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type NetSuiteCredentials = {
  __typename?: 'NetSuiteCredentials';
  account_id: Scalars['String']['output'];
  consumer_key: Scalars['String']['output'];
  consumer_secret: Scalars['String']['output'];
  token_id: Scalars['String']['output'];
  token_secret: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NetSuiteCredentialsInput = {
  account_id: Scalars['String']['input'];
  consumer_key: Scalars['String']['input'];
  consumer_secret: Scalars['String']['input'];
  token_id: Scalars['String']['input'];
  token_secret: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type NetSuiteOAuth2Credentials = {
  __typename?: 'NetSuiteOAuth2Credentials';
  account_id: Scalars['String']['output'];
  client_id: Scalars['String']['output'];
  client_secret: Scalars['String']['output'];
  refresh_token: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NetSuiteOAuth2CredentialsInput = {
  account_id: Scalars['String']['input'];
  client_id: Scalars['String']['input'];
  client_secret: Scalars['String']['input'];
  refresh_token: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ParquetUploadResult = {
  __typename?: 'ParquetUploadResult';
  message: Scalars['String']['output'];
  runId: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type PoActionInput = {
  action: PoActionType;
  cost?: InputMaybe<Scalars['Float']['input']>;
  location: Scalars['String']['input'];
  order_delivery_date?: InputMaybe<Scalars['String']['input']>;
  order_placed_date?: InputMaybe<Scalars['String']['input']>;
  pallets?: InputMaybe<Scalars['Float']['input']>;
  purchase_order_id: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sku: Scalars['String']['input'];
  sku_name?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  total_cost?: InputMaybe<Scalars['Float']['input']>;
  unit_cost?: InputMaybe<Scalars['Float']['input']>;
};

export enum PoActionType {
  Approve = 'APPROVE',
  Unapprove = 'UNAPPROVE'
}

export type PreloadDataset = {
  __typename?: 'PreloadDataset';
  paramsJSON: Scalars['String']['output'];
  viewDatasetTransform: Scalars['String']['output'];
};

export type PresentedCheckMethodology = {
  __typename?: 'PresentedCheckMethodology';
  filesUsed: Array<Scalars['String']['output']>;
  formula: Scalars['String']['output'];
  thresholdLines: Array<Scalars['String']['output']>;
};

export type PresentedValidationFinding = {
  __typename?: 'PresentedValidationFinding';
  checkId: Scalars['String']['output'];
  evidenceLines: Array<Scalars['String']['output']>;
  executionStatus: Scalars['String']['output'];
  methodology: PresentedCheckMethodology;
  nextSteps: Array<Scalars['String']['output']>;
  primaryDomain: Scalars['String']['output'];
  resultSummary: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  title: Scalars['String']['output'];
  whatHappened: Scalars['String']['output'];
  whyItMatters: Scalars['String']['output'];
};

export type PresentedValidationReport = {
  __typename?: 'PresentedValidationReport';
  context: ValidationReportContext;
  findings: Array<PresentedValidationFinding>;
  headline: Scalars['String']['output'];
  healthyChecks: Array<Scalars['String']['output']>;
  overallSeverity: Scalars['String']['output'];
  overallStatusExplained: Scalars['String']['output'];
  recommendedNextSteps: Array<Scalars['String']['output']>;
  reportVersion: Scalars['String']['output'];
  technicalSummary: ValidationTechnicalSummary;
};

export type Query = {
  __typename?: 'Query';
  getAllCustomers: Array<Customer>;
  getAllCustomersWithFeatureFlags: Array<CustomerWithFeatureFlags>;
  getAllMyEngineSettings: Array<EngineSettings>;
  getAnyFileDownloadUrl?: Maybe<Scalars['String']['output']>;
  getCustomer?: Maybe<Customer>;
  getLatestRuns: Array<Run>;
  getMyCredentials?: Maybe<Scalars['String']['output']>;
  getMyCustomer?: Maybe<MyCustomer>;
  getMyDataFileDownloadUrl?: Maybe<Scalars['String']['output']>;
  getMyDataFileOverrideUploadUrl?: Maybe<Scalars['String']['output']>;
  getMyDataFileWithOverrideDownloadUrl?: Maybe<Scalars['String']['output']>;
  getMyEditedLayer?: Maybe<Layer>;
  getMyEngineSettings?: Maybe<EngineSettings>;
  getMyEngineSettingsFileNames: Array<Scalars['String']['output']>;
  getMyInputDatastructureNames: Array<Scalars['String']['output']>;
  getMyInputIds: Array<Scalars['String']['output']>;
  getMyLayerOfEngineSettings?: Maybe<Layer>;
  getMyOutputDatastructureNames: Array<Scalars['String']['output']>;
  getMyOutputIds: Array<Scalars['String']['output']>;
  getMyPullSourceConfig?: Maybe<Scalars['String']['output']>;
  getMyRawInputDatastructureNames: Array<Scalars['String']['output']>;
  getMyRawInputIds: Array<Scalars['String']['output']>;
  getMyRunComparisonSummary?: Maybe<Scalars['String']['output']>;
  getMyRuns: Array<Run>;
  getMySteps?: Maybe<Array<Step>>;
  getMyTeamMembers: Array<User>;
  /**
   * Time-limited HTTPS URL to download a validator artifact (presented or raw JSON) for this run.
   * ROOT/ADMIN only.
   */
  getMyValidationArtifactDownloadUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Structured presented_report.json from atomic-validator for this run, if present in the data-files bucket.
   * ROOT/ADMIN only; S3 key layout matches atomic_validator.io.report_persistence.
   */
  getMyValidationPresentedReport?: Maybe<PresentedValidationReport>;
  getMyValidationReportComparison?: Maybe<ValidationReportComparison>;
  getMyValidationSettings?: Maybe<ValidationSettings>;
  whoAmI?: Maybe<User>;
};


export type QueryGetAnyFileDownloadUrlArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetCustomerArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryGetMyDataFileDownloadUrlArgs = {
  dataName: Scalars['String']['input'];
  fileFormat: Scalars['String']['input'];
  runSettings: MyRunSettingsInput;
};


export type QueryGetMyDataFileOverrideUploadUrlArgs = {
  dataName: Scalars['String']['input'];
  fileFormat: Scalars['String']['input'];
  runSettings: MyRunSettingsInput;
};


export type QueryGetMyDataFileWithOverrideDownloadUrlArgs = {
  dataName: Scalars['String']['input'];
  fileFormat: Scalars['String']['input'];
  runSettings: MyRunSettingsInput;
};


export type QueryGetMyEditedLayerArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetMyEngineSettingsArgs = {
  settingsName: Scalars['String']['input'];
  settingsVersion: Scalars['String']['input'];
};


export type QueryGetMyEngineSettingsFileNamesArgs = {
  settingsName: Scalars['String']['input'];
  settingsVersion: Scalars['String']['input'];
};


export type QueryGetMyInputDatastructureNamesArgs = {
  inputId: Scalars['String']['input'];
};


export type QueryGetMyLayerOfEngineSettingsArgs = {
  settingsName: Scalars['String']['input'];
  settingsVersion: Scalars['String']['input'];
};


export type QueryGetMyOutputDatastructureNamesArgs = {
  outputId: Scalars['String']['input'];
};


export type QueryGetMyRawInputDatastructureNamesArgs = {
  inputId: Scalars['String']['input'];
};


export type QueryGetMyRunComparisonSummaryArgs = {
  runSettings1: MyRunSettingsInput;
  runSettings2: MyRunSettingsInput;
};


export type QueryGetMyStepsArgs = {
  runSettings: MyRunSettingsInput;
};


export type QueryGetMyValidationArtifactDownloadUrlArgs = {
  artifact: ValidationReportArtifact;
  runSettings: MyRunSettingsInput;
};


export type QueryGetMyValidationPresentedReportArgs = {
  runSettings: MyRunSettingsInput;
};


export type QueryGetMyValidationReportComparisonArgs = {
  runSettings1: MyRunSettingsInput;
  runSettings2: MyRunSettingsInput;
};

export enum Role {
  Admin = 'ADMIN',
  None = 'NONE',
  Root = 'ROOT'
}

export type Run = {
  __typename?: 'Run';
  atStep?: Maybe<Scalars['Int']['output']>;
  comparisonWithPreviousRunJson?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayId?: Maybe<Scalars['String']['output']>;
  engineInProgress?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  initiatedBy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  runSettings: RunSettings;
  status: RunStatus;
  stepIds?: Maybe<Scalars['String']['output']>;
  totalSteps?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type RunInput = {
  inputId: Scalars['String']['input'];
  runAttemptId: Scalars['String']['input'];
  settingsNameAndVersion: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type RunSettings = {
  __typename?: 'RunSettings';
  inputId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  runAttemptId: Scalars['String']['output'];
  settingsNameAndVersion: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type RunSettingsInput = {
  inputId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  runAttemptId: Scalars['String']['input'];
  settingsNameAndVersion: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export enum RunStatus {
  CancelCompleted = 'CANCEL_COMPLETED',
  CancelFailed = 'CANCEL_FAILED',
  CancelInProgress = 'CANCEL_IN_PROGRESS',
  RunCompleted = 'RUN_COMPLETED',
  RunFailed = 'RUN_FAILED',
  RunInProgress = 'RUN_IN_PROGRESS',
  ToRun = 'TO_RUN'
}

export type SaveApprovedPOsBatchResult = {
  __typename?: 'SaveApprovedPOsBatchResult';
  appliedCount: Scalars['Int']['output'];
  s3Key?: Maybe<Scalars['String']['output']>;
};

export type SaveMyValidationSettingsInput = {
  json: Scalars['String']['input'];
};

export type SourceCredential = {
  __typename?: 'SourceCredential';
  credentials: Array<Credential>;
};

export type SourceCredentialInput = {
  credentials: Array<CredentialInput>;
};

export type Step = {
  __typename?: 'Step';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  runSettings: RunSettings;
  status: StepStatus;
};

export enum StepStatus {
  ExecutionCompleted = 'EXECUTION_COMPLETED',
  ExecutionFailed = 'EXECUTION_FAILED',
  ExecutionQueued = 'EXECUTION_QUEUED',
  ExecutionStarted = 'EXECUTION_STARTED',
  ToExecute = 'TO_EXECUTE'
}

export type User = {
  __typename?: 'User';
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type UserRunSettingsInput = {
  inputId: Scalars['String']['input'];
  runAttemptId: Scalars['String']['input'];
  settingsName: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type ValidationCheckChange = {
  __typename?: 'ValidationCheckChange';
  changed: Scalars['Boolean']['output'];
  checkId: Scalars['String']['output'];
  metricAfter?: Maybe<Scalars['Float']['output']>;
  metricBefore?: Maybe<Scalars['Float']['output']>;
  metricDelta?: Maybe<Scalars['Float']['output']>;
  metricLabel?: Maybe<Scalars['String']['output']>;
  primaryDomain: Scalars['String']['output'];
  resultSummaryAfter?: Maybe<Scalars['String']['output']>;
  resultSummaryBefore?: Maybe<Scalars['String']['output']>;
  severityAfter: Scalars['String']['output'];
  severityBefore: Scalars['String']['output'];
  whatHappenedAfter?: Maybe<Scalars['String']['output']>;
  whatHappenedBefore?: Maybe<Scalars['String']['output']>;
};

/** atomic-validator persistence: presented_report.json or raw_report.json under the run's validations prefix. */
export enum ValidationReportArtifact {
  PresentedReport = 'PRESENTED_REPORT',
  RawReport = 'RAW_REPORT'
}

export type ValidationReportComparison = {
  __typename?: 'ValidationReportComparison';
  checkChanges: Array<ValidationCheckChange>;
  overallSeverityAfter: Scalars['String']['output'];
  overallSeverityBefore: Scalars['String']['output'];
  run1Timestamp: Scalars['String']['output'];
  run2Timestamp: Scalars['String']['output'];
  summary1: ValidationTechnicalSummary;
  summary2: ValidationTechnicalSummary;
};

export type ValidationReportContext = {
  __typename?: 'ValidationReportContext';
  availableArtifacts: Array<Scalars['String']['output']>;
  enabledCheckIds?: Maybe<Array<Scalars['String']['output']>>;
  environment?: Maybe<Scalars['String']['output']>;
  inputId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  runAttemptId?: Maybe<Scalars['String']['output']>;
  settingsNameAndVersion?: Maybe<Scalars['String']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type ValidationSettings = {
  __typename?: 'ValidationSettings';
  json: Scalars['String']['output'];
};

export type ValidationTechnicalSummary = {
  __typename?: 'ValidationTechnicalSummary';
  blockerCount: Scalars['Int']['output'];
  executedCount: Scalars['Int']['output'];
  executionErrorCount: Scalars['Int']['output'];
  passCount: Scalars['Int']['output'];
  skippedMissingArtifactsCount: Scalars['Int']['output'];
  slowestCheckDurationMs: Scalars['Int']['output'];
  slowestCheckId: Scalars['String']['output'];
  totalCheckCount: Scalars['Int']['output'];
  totalDurationMs: Scalars['Int']['output'];
  warningCount: Scalars['Int']['output'];
};

export type CreateMyEmailDomainMutationVariables = Exact<{
  emailDomain: Scalars['String']['input'];
}>;


export type CreateMyEmailDomainMutation = { __typename?: 'Mutation', createMyEmailDomain?: { __typename?: 'Customer', id: string, emailDomains?: Array<string> | null } | null };

export type DeleteMyEmailDomainMutationVariables = Exact<{
  emailDomain: Scalars['String']['input'];
}>;


export type DeleteMyEmailDomainMutation = { __typename?: 'Mutation', deleteMyEmailDomain?: { __typename?: 'Customer', id: string, emailDomains?: Array<string> | null } | null };

export type InviteMyTeamMemberMutationVariables = Exact<{
  email: Scalars['String']['input'];
  temporaryPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type InviteMyTeamMemberMutation = { __typename?: 'Mutation', inviteMyTeamMember?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, role?: string | null, customerId?: string | null, status?: string | null } | null };

export type RemoveMyTeamMemberMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RemoveMyTeamMemberMutation = { __typename?: 'Mutation', removeMyTeamMember?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, role?: string | null, customerId?: string | null, status?: string | null } | null };

export type SetMyTeamMemberTemporaryPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  temporaryPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetMyTeamMemberTemporaryPasswordMutation = { __typename?: 'Mutation', setMyTeamMemberTemporaryPassword?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, role?: string | null, customerId?: string | null, status?: string | null } | null };

export type CancelMyRunMutationVariables = Exact<{
  runSettings: RunInput;
}>;


export type CancelMyRunMutation = { __typename?: 'Mutation', cancelMyRun?: string | null };

export type CopyForecastToDefaultSettingsMutationVariables = Exact<{
  sourceInputId: Scalars['String']['input'];
  sourceSettingsNameAndVersion: Scalars['String']['input'];
  sourceRunId: Scalars['String']['input'];
}>;


export type CopyForecastToDefaultSettingsMutation = { __typename?: 'Mutation', copyForecastToDefaultSettings?: { __typename?: 'MyCustomer', defaultEngineSettingName?: string | null, defaultEngineSettingVersion?: string | null, forecastLockedToRunId?: string | null } | null };

export type CreateCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  defaultRole: Scalars['String']['input'];
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'Customer', name: string, id: string, defaultRole?: string | null } | null };

export type CreateCustomerEmailDomainMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  emailDomain: Scalars['String']['input'];
}>;


export type CreateCustomerEmailDomainMutation = { __typename?: 'Mutation', createCustomerEmailDomain?: { __typename?: 'Customer', id: string, emailDomains?: Array<string> | null } | null };

export type CreateOrReplaceFeatureFlagsMutationVariables = Exact<{
  featureFlags: FeatureFlagsInput;
}>;


export type CreateOrReplaceFeatureFlagsMutation = { __typename?: 'Mutation', createOrReplaceFeatureFlags?: string | null };

export type DeleteCustomerEmailDomainMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  emailDomain: Scalars['String']['input'];
}>;


export type DeleteCustomerEmailDomainMutation = { __typename?: 'Mutation', deleteCustomerEmailDomain?: { __typename?: 'Customer', id: string, emailDomains?: Array<string> | null } | null };

export type ExecuteMyLayerChangeSetMutationVariables = Exact<{
  layerId: Scalars['String']['input'];
  layerChangeSet: LayerChangeSetInput;
}>;


export type ExecuteMyLayerChangeSetMutation = { __typename?: 'Mutation', executeMyLayerChangeSet?: { __typename?: 'Layer', id: string, rows: Array<{ __typename?: 'LayerRow', id: string, createdAt: string, createdBy: string, source?: string | null, adjustmentId: string, adjustmentLevel: string, periodStart: string, periodEnd?: string | null, value?: number | null }> } | null };

export type GetAllCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCustomersQuery = { __typename?: 'Query', getAllCustomers: Array<{ __typename?: 'Customer', name: string, id: string }> };

export type GetAllMyEngineSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMyEngineSettingsQuery = { __typename?: 'Query', getAllMyEngineSettings: Array<{ __typename?: 'EngineSettings', id: string, name: string, version: string, default: boolean, json?: string | null }> };

export type GetCustomerQueryVariables = Exact<{
  customerId: Scalars['String']['input'];
}>;


export type GetCustomerQuery = { __typename?: 'Query', getCustomer?: { __typename?: 'Customer', name: string, id: string, features?: string | null, emailDomains?: Array<string> | null, defaultRole?: string | null } | null };

export type GetLatestRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestRunsQuery = { __typename?: 'Query', getLatestRuns: Array<{ __typename?: 'Run', id: string, status: RunStatus, createdAt: string, updatedAt: string, initiatedBy?: string | null, name?: string | null, description?: string | null, customerId?: string | null, runSettings: { __typename?: 'RunSettings', inputId: string, workflowId: string, settingsNameAndVersion: string, runAttemptId: string } }> };

export type GetMyCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCustomerQuery = { __typename?: 'Query', getMyCustomer?: { __typename?: 'MyCustomer', name: string, id: string, features?: string | null, ej2License?: string | null, muiLicense?: string | null, defaultEngineSettingName?: string | null, defaultEngineSettingVersion?: string | null, forecastLockedToRunId?: string | null, preloadDatasets?: Array<{ __typename?: 'PreloadDataset', viewDatasetTransform: string, paramsJSON: string }> | null } | null };

export type GetMyDataFileDownloadUrlQueryVariables = Exact<{
  runSettings: MyRunSettingsInput;
  dataName: Scalars['String']['input'];
  fileFormat: Scalars['String']['input'];
}>;


export type GetMyDataFileDownloadUrlQuery = { __typename?: 'Query', getMyDataFileDownloadUrl?: string | null };

export type GetMyDataFileOverrideUploadUrlQueryVariables = Exact<{
  runSettings: MyRunSettingsInput;
  dataName: Scalars['String']['input'];
  fileFormat: Scalars['String']['input'];
}>;


export type GetMyDataFileOverrideUploadUrlQuery = { __typename?: 'Query', getMyDataFileOverrideUploadUrl?: string | null };

export type GetMyDataFileWithOverrideDownloadUrlQueryVariables = Exact<{
  runSettings: MyRunSettingsInput;
  dataName: Scalars['String']['input'];
  fileFormat: Scalars['String']['input'];
}>;


export type GetMyDataFileWithOverrideDownloadUrlQuery = { __typename?: 'Query', getMyDataFileWithOverrideDownloadUrl?: string | null };

export type GetMyEditedLayerQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetMyEditedLayerQuery = { __typename?: 'Query', getMyEditedLayer?: { __typename?: 'Layer', id: string, rows: Array<{ __typename?: 'LayerRow', id: string, createdAt: string, createdBy: string, source?: string | null, adjustmentId: string, adjustmentLevel: string, periodStart: string, periodEnd?: string | null, value?: number | null }> } | null };

export type GetMyEngineSettingsQueryVariables = Exact<{
  settingsName: Scalars['String']['input'];
  settingsVersion: Scalars['String']['input'];
}>;


export type GetMyEngineSettingsQuery = { __typename?: 'Query', getMyEngineSettings?: { __typename?: 'EngineSettings', id: string, name: string, version: string, default: boolean, json?: string | null, layer?: { __typename?: 'Layer', id: string, rows: Array<{ __typename?: 'LayerRow', id: string, createdAt: string, createdBy: string, source?: string | null, adjustmentId: string, adjustmentLevel: string, periodStart: string, periodEnd?: string | null, value?: number | null }> } | null } | null };

export type GetMyInputDatastructureNamesQueryVariables = Exact<{
  inputId: Scalars['String']['input'];
}>;


export type GetMyInputDatastructureNamesQuery = { __typename?: 'Query', getMyInputDatastructureNames: Array<string> };

export type GetMyInputIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyInputIdsQuery = { __typename?: 'Query', getMyInputIds: Array<string> };

export type GetMyOutputDatastructureNamesQueryVariables = Exact<{
  outputId: Scalars['String']['input'];
}>;


export type GetMyOutputDatastructureNamesQuery = { __typename?: 'Query', getMyOutputDatastructureNames: Array<string> };

export type GetMyRunComparisonSummaryQueryVariables = Exact<{
  runSettings1: MyRunSettingsInput;
  runSettings2: MyRunSettingsInput;
}>;


export type GetMyRunComparisonSummaryQuery = { __typename?: 'Query', getMyRunComparisonSummary?: string | null };

export type GetMyRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyRunsQuery = { __typename?: 'Query', getMyRuns: Array<{ __typename?: 'Run', id: string, status: RunStatus, createdAt: string, updatedAt: string, stepIds?: string | null, initiatedBy?: string | null, name?: string | null, description?: string | null, atStep?: number | null, totalSteps?: number | null, engineInProgress?: boolean | null, comparisonWithPreviousRunJson?: string | null, runSettings: { __typename?: 'RunSettings', inputId: string, organizationId: string, workflowId: string, settingsNameAndVersion: string, runAttemptId: string } }> };

export type GetMyTeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyTeamMembersQuery = { __typename?: 'Query', getMyTeamMembers: Array<{ __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, role?: string | null, customerId?: string | null, status?: string | null }> };

export type MakeMyEngineSettingsDefaultMutationVariables = Exact<{
  settingsName: Scalars['String']['input'];
  settingsVersion?: InputMaybe<Scalars['String']['input']>;
}>;


export type MakeMyEngineSettingsDefaultMutation = { __typename?: 'Mutation', makeMyEngineSettingsDefault?: { __typename?: 'MyCustomer', defaultEngineSettingName?: string | null, defaultEngineSettingVersion?: string | null } | null };

export type RerunMyStepMutationVariables = Exact<{
  runSettings: MyRunSettingsInput;
  stepId: Scalars['String']['input'];
}>;


export type RerunMyStepMutation = { __typename?: 'Mutation', rerunMyStep?: string | null };

export type RetryMyRunMutationVariables = Exact<{
  runSettings: RunInput;
}>;


export type RetryMyRunMutation = { __typename?: 'Mutation', retryMyRun?: string | null };

export type SaveApprovedPOsMutationVariables = Exact<{
  runSettings: MyRunSettingsInput;
  poAction: PoActionInput;
}>;


export type SaveApprovedPOsMutation = { __typename?: 'Mutation', saveApprovedPOs?: string | null };

export type SaveApprovedPOsBatchMutationVariables = Exact<{
  runSettings: MyRunSettingsInput;
  actions: Array<PoActionInput> | PoActionInput;
}>;


export type SaveApprovedPOsBatchMutation = { __typename?: 'Mutation', saveApprovedPOsBatch?: { __typename?: 'SaveApprovedPOsBatchResult', s3Key?: string | null, appliedCount: number } | null };

export type SavePurchasingCalendarOverrideToDefaultSettingsMutationVariables = Exact<{
  fileContent: Scalars['String']['input'];
  runSettings?: InputMaybe<UserRunSettingsInput>;
}>;


export type SavePurchasingCalendarOverrideToDefaultSettingsMutation = { __typename?: 'Mutation', savePurchasingCalendarOverrideToDefaultSettings?: { __typename?: 'MyCustomer', defaultEngineSettingName?: string | null, defaultEngineSettingVersion?: string | null } | null };

export type SetMyRunDescriptionMutationVariables = Exact<{
  runSettings: MyRunSettingsInput;
  description: Scalars['String']['input'];
}>;


export type SetMyRunDescriptionMutation = { __typename?: 'Mutation', setMyRunDescription?: string | null };

export type SetMyRunNameMutationVariables = Exact<{
  runSettings: MyRunSettingsInput;
  name: Scalars['String']['input'];
}>;


export type SetMyRunNameMutation = { __typename?: 'Mutation', setMyRunName?: string | null };

export type StartMyRecalculatedUserRunMutationVariables = Exact<{
  runSettings: UserRunSettingsInput;
}>;


export type StartMyRecalculatedUserRunMutation = { __typename?: 'Mutation', startMyRecalculatedUserRun?: { __typename?: 'Run', status: RunStatus, createdAt: string, updatedAt: string, stepIds?: string | null, initiatedBy?: string | null, name?: string | null, description?: string | null, runSettings: { __typename?: 'RunSettings', inputId: string, workflowId: string, settingsNameAndVersion: string, runAttemptId: string } } | null };

export type StartMyRunMutationVariables = Exact<{
  runSettings: MyRunSettingsInput;
}>;


export type StartMyRunMutation = { __typename?: 'Mutation', startMyRun?: { __typename?: 'Run', id: string, status: RunStatus, createdAt: string, updatedAt: string, stepIds?: string | null, initiatedBy?: string | null, name?: string | null, description?: string | null, atStep?: number | null, totalSteps?: number | null, engineInProgress?: boolean | null, runSettings: { __typename?: 'RunSettings', inputId: string, organizationId: string, workflowId: string, settingsNameAndVersion: string, runAttemptId: string } } | null };

export type StartMySheetImporterSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type StartMySheetImporterSyncMutation = { __typename?: 'Mutation', startMySheetImporterSync?: string | null };

export type StartMyUserRunMutationVariables = Exact<{
  runSettings: UserRunSettingsInput;
}>;


export type StartMyUserRunMutation = { __typename?: 'Mutation', startMyUserRun?: { __typename?: 'Run', status: RunStatus, createdAt: string, updatedAt: string, stepIds?: string | null, initiatedBy?: string | null, name?: string | null, description?: string | null, atStep?: number | null, totalSteps?: number | null, engineInProgress?: boolean | null, runSettings: { __typename?: 'RunSettings', inputId: string, organizationId: string, workflowId: string, settingsNameAndVersion: string, runAttemptId: string } } | null };

export type StoreMyEditedLayerAsSettingsMutationVariables = Exact<{
  layerId: Scalars['String']['input'];
  settingsName: Scalars['String']['input'];
  settingsVersion: Scalars['String']['input'];
}>;


export type StoreMyEditedLayerAsSettingsMutation = { __typename?: 'Mutation', storeMyEditedLayerAsSettings?: { __typename?: 'EngineSettings', id: string, name: string, version: string, default: boolean, json?: string | null, layer?: { __typename?: 'Layer', id: string, rows: Array<{ __typename?: 'LayerRow', id: string, createdAt: string, createdBy: string, source?: string | null, adjustmentId: string, adjustmentLevel: string, periodStart: string, periodEnd?: string | null, value?: number | null }> } | null } | null };

export type StoreMyViewForPreloadMutationVariables = Exact<{
  datasetName: Scalars['String']['input'];
  transformId: Scalars['String']['input'];
  paramsJSON: Scalars['String']['input'];
  pinName?: InputMaybe<Scalars['String']['input']>;
  setAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  oldPinName?: InputMaybe<Scalars['String']['input']>;
  deletePinName?: InputMaybe<Scalars['String']['input']>;
}>;


export type StoreMyViewForPreloadMutation = { __typename?: 'Mutation', storeMyViewForPreload?: { __typename?: 'MyCustomer', name: string, id: string, features?: string | null, ej2License?: string | null, muiLicense?: string | null, defaultEngineSettingName?: string | null, defaultEngineSettingVersion?: string | null, preloadDatasets?: Array<{ __typename?: 'PreloadDataset', viewDatasetTransform: string, paramsJSON: string }> | null } | null };

export type TriggerMyRunNextStepsMutationVariables = Exact<{
  runSettings: RunInput;
}>;


export type TriggerMyRunNextStepsMutation = { __typename?: 'Mutation', triggerMyRunNextSteps?: string | null };

export type UnlockForecastFromDefaultSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type UnlockForecastFromDefaultSettingsMutation = { __typename?: 'Mutation', unlockForecastFromDefaultSettings?: { __typename?: 'MyCustomer', defaultEngineSettingName?: string | null, defaultEngineSettingVersion?: string | null, forecastLockedToRunId?: string | null } | null };

export type UploadAndTriggerMyRunMutationVariables = Exact<{
  fileContent: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  runSettings: MyRunSettingsInput;
  runName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadAndTriggerMyRunMutation = { __typename?: 'Mutation', uploadFinalLayerAndStartMyRun: { __typename?: 'ParquetUploadResult', success: boolean, s3Key: string, message: string, runId: string } };

export type WhoAmIQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoAmIQuery = { __typename?: 'Query', whoAmI?: { __typename?: 'User', id?: string | null, name?: string | null, email?: string | null, picture?: string | null, phoneNumber?: string | null, role?: string | null, customerId?: string | null } | null };


export const CreateMyEmailDomainDocument = gql`
    mutation CreateMyEmailDomain($emailDomain: String!) {
  createMyEmailDomain(emailDomain: $emailDomain) {
    id
    emailDomains
  }
}
    `;
export type CreateMyEmailDomainMutationFn = Apollo.MutationFunction<CreateMyEmailDomainMutation, CreateMyEmailDomainMutationVariables>;

/**
 * __useCreateMyEmailDomainMutation__
 *
 * To run a mutation, you first call `useCreateMyEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMyEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMyEmailDomainMutation, { data, loading, error }] = useCreateMyEmailDomainMutation({
 *   variables: {
 *      emailDomain: // value for 'emailDomain'
 *   },
 * });
 */
export function useCreateMyEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<CreateMyEmailDomainMutation, CreateMyEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMyEmailDomainMutation, CreateMyEmailDomainMutationVariables>(CreateMyEmailDomainDocument, options);
      }
export type CreateMyEmailDomainMutationHookResult = ReturnType<typeof useCreateMyEmailDomainMutation>;
export type CreateMyEmailDomainMutationResult = Apollo.MutationResult<CreateMyEmailDomainMutation>;
export type CreateMyEmailDomainMutationOptions = Apollo.BaseMutationOptions<CreateMyEmailDomainMutation, CreateMyEmailDomainMutationVariables>;
export const DeleteMyEmailDomainDocument = gql`
    mutation DeleteMyEmailDomain($emailDomain: String!) {
  deleteMyEmailDomain(emailDomain: $emailDomain) {
    id
    emailDomains
  }
}
    `;
export type DeleteMyEmailDomainMutationFn = Apollo.MutationFunction<DeleteMyEmailDomainMutation, DeleteMyEmailDomainMutationVariables>;

/**
 * __useDeleteMyEmailDomainMutation__
 *
 * To run a mutation, you first call `useDeleteMyEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMyEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMyEmailDomainMutation, { data, loading, error }] = useDeleteMyEmailDomainMutation({
 *   variables: {
 *      emailDomain: // value for 'emailDomain'
 *   },
 * });
 */
export function useDeleteMyEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMyEmailDomainMutation, DeleteMyEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMyEmailDomainMutation, DeleteMyEmailDomainMutationVariables>(DeleteMyEmailDomainDocument, options);
      }
export type DeleteMyEmailDomainMutationHookResult = ReturnType<typeof useDeleteMyEmailDomainMutation>;
export type DeleteMyEmailDomainMutationResult = Apollo.MutationResult<DeleteMyEmailDomainMutation>;
export type DeleteMyEmailDomainMutationOptions = Apollo.BaseMutationOptions<DeleteMyEmailDomainMutation, DeleteMyEmailDomainMutationVariables>;
export const InviteMyTeamMemberDocument = gql`
    mutation InviteMyTeamMember($email: String!, $temporaryPassword: String) {
  inviteMyTeamMember(email: $email, temporaryPassword: $temporaryPassword) {
    id
    name
    email
    role
    customerId
    status
  }
}
    `;
export type InviteMyTeamMemberMutationFn = Apollo.MutationFunction<InviteMyTeamMemberMutation, InviteMyTeamMemberMutationVariables>;

/**
 * __useInviteMyTeamMemberMutation__
 *
 * To run a mutation, you first call `useInviteMyTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMyTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMyTeamMemberMutation, { data, loading, error }] = useInviteMyTeamMemberMutation({
 *   variables: {
 *      email: // value for 'email'
 *      temporaryPassword: // value for 'temporaryPassword'
 *   },
 * });
 */
export function useInviteMyTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<InviteMyTeamMemberMutation, InviteMyTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteMyTeamMemberMutation, InviteMyTeamMemberMutationVariables>(InviteMyTeamMemberDocument, options);
      }
export type InviteMyTeamMemberMutationHookResult = ReturnType<typeof useInviteMyTeamMemberMutation>;
export type InviteMyTeamMemberMutationResult = Apollo.MutationResult<InviteMyTeamMemberMutation>;
export type InviteMyTeamMemberMutationOptions = Apollo.BaseMutationOptions<InviteMyTeamMemberMutation, InviteMyTeamMemberMutationVariables>;
export const RemoveMyTeamMemberDocument = gql`
    mutation RemoveMyTeamMember($email: String!) {
  removeMyTeamMember(email: $email) {
    id
    name
    email
    role
    customerId
    status
  }
}
    `;
export type RemoveMyTeamMemberMutationFn = Apollo.MutationFunction<RemoveMyTeamMemberMutation, RemoveMyTeamMemberMutationVariables>;

/**
 * __useRemoveMyTeamMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMyTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMyTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMyTeamMemberMutation, { data, loading, error }] = useRemoveMyTeamMemberMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRemoveMyTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMyTeamMemberMutation, RemoveMyTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMyTeamMemberMutation, RemoveMyTeamMemberMutationVariables>(RemoveMyTeamMemberDocument, options);
      }
export type RemoveMyTeamMemberMutationHookResult = ReturnType<typeof useRemoveMyTeamMemberMutation>;
export type RemoveMyTeamMemberMutationResult = Apollo.MutationResult<RemoveMyTeamMemberMutation>;
export type RemoveMyTeamMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMyTeamMemberMutation, RemoveMyTeamMemberMutationVariables>;
export const SetMyTeamMemberTemporaryPasswordDocument = gql`
    mutation SetMyTeamMemberTemporaryPassword($email: String!, $temporaryPassword: String) {
  setMyTeamMemberTemporaryPassword(
    email: $email
    temporaryPassword: $temporaryPassword
  ) {
    id
    name
    email
    role
    customerId
    status
  }
}
    `;
export type SetMyTeamMemberTemporaryPasswordMutationFn = Apollo.MutationFunction<SetMyTeamMemberTemporaryPasswordMutation, SetMyTeamMemberTemporaryPasswordMutationVariables>;

/**
 * __useSetMyTeamMemberTemporaryPasswordMutation__
 *
 * To run a mutation, you first call `useSetMyTeamMemberTemporaryPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyTeamMemberTemporaryPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyTeamMemberTemporaryPasswordMutation, { data, loading, error }] = useSetMyTeamMemberTemporaryPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      temporaryPassword: // value for 'temporaryPassword'
 *   },
 * });
 */
export function useSetMyTeamMemberTemporaryPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetMyTeamMemberTemporaryPasswordMutation, SetMyTeamMemberTemporaryPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyTeamMemberTemporaryPasswordMutation, SetMyTeamMemberTemporaryPasswordMutationVariables>(SetMyTeamMemberTemporaryPasswordDocument, options);
      }
export type SetMyTeamMemberTemporaryPasswordMutationHookResult = ReturnType<typeof useSetMyTeamMemberTemporaryPasswordMutation>;
export type SetMyTeamMemberTemporaryPasswordMutationResult = Apollo.MutationResult<SetMyTeamMemberTemporaryPasswordMutation>;
export type SetMyTeamMemberTemporaryPasswordMutationOptions = Apollo.BaseMutationOptions<SetMyTeamMemberTemporaryPasswordMutation, SetMyTeamMemberTemporaryPasswordMutationVariables>;
export const CancelMyRunDocument = gql`
    mutation CancelMyRun($runSettings: RunInput!) {
  cancelMyRun(runSettings: $runSettings)
}
    `;
export type CancelMyRunMutationFn = Apollo.MutationFunction<CancelMyRunMutation, CancelMyRunMutationVariables>;

/**
 * __useCancelMyRunMutation__
 *
 * To run a mutation, you first call `useCancelMyRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMyRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMyRunMutation, { data, loading, error }] = useCancelMyRunMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useCancelMyRunMutation(baseOptions?: Apollo.MutationHookOptions<CancelMyRunMutation, CancelMyRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMyRunMutation, CancelMyRunMutationVariables>(CancelMyRunDocument, options);
      }
export type CancelMyRunMutationHookResult = ReturnType<typeof useCancelMyRunMutation>;
export type CancelMyRunMutationResult = Apollo.MutationResult<CancelMyRunMutation>;
export type CancelMyRunMutationOptions = Apollo.BaseMutationOptions<CancelMyRunMutation, CancelMyRunMutationVariables>;
export const CopyForecastToDefaultSettingsDocument = gql`
    mutation CopyForecastToDefaultSettings($sourceInputId: String!, $sourceSettingsNameAndVersion: String!, $sourceRunId: String!) {
  copyForecastToDefaultSettings(
    sourceInputId: $sourceInputId
    sourceSettingsNameAndVersion: $sourceSettingsNameAndVersion
    sourceRunId: $sourceRunId
  ) {
    defaultEngineSettingName
    defaultEngineSettingVersion
    forecastLockedToRunId
  }
}
    `;
export type CopyForecastToDefaultSettingsMutationFn = Apollo.MutationFunction<CopyForecastToDefaultSettingsMutation, CopyForecastToDefaultSettingsMutationVariables>;

/**
 * __useCopyForecastToDefaultSettingsMutation__
 *
 * To run a mutation, you first call `useCopyForecastToDefaultSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyForecastToDefaultSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyForecastToDefaultSettingsMutation, { data, loading, error }] = useCopyForecastToDefaultSettingsMutation({
 *   variables: {
 *      sourceInputId: // value for 'sourceInputId'
 *      sourceSettingsNameAndVersion: // value for 'sourceSettingsNameAndVersion'
 *      sourceRunId: // value for 'sourceRunId'
 *   },
 * });
 */
export function useCopyForecastToDefaultSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CopyForecastToDefaultSettingsMutation, CopyForecastToDefaultSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyForecastToDefaultSettingsMutation, CopyForecastToDefaultSettingsMutationVariables>(CopyForecastToDefaultSettingsDocument, options);
      }
export type CopyForecastToDefaultSettingsMutationHookResult = ReturnType<typeof useCopyForecastToDefaultSettingsMutation>;
export type CopyForecastToDefaultSettingsMutationResult = Apollo.MutationResult<CopyForecastToDefaultSettingsMutation>;
export type CopyForecastToDefaultSettingsMutationOptions = Apollo.BaseMutationOptions<CopyForecastToDefaultSettingsMutation, CopyForecastToDefaultSettingsMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($id: String!, $name: String!, $defaultRole: String!) {
  createCustomer(id: $id, name: $name, defaultRole: $defaultRole) {
    name
    id
    defaultRole
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      defaultRole: // value for 'defaultRole'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CreateCustomerEmailDomainDocument = gql`
    mutation CreateCustomerEmailDomain($customerId: String!, $emailDomain: String!) {
  createCustomerEmailDomain(customerId: $customerId, emailDomain: $emailDomain) {
    id
    emailDomains
  }
}
    `;
export type CreateCustomerEmailDomainMutationFn = Apollo.MutationFunction<CreateCustomerEmailDomainMutation, CreateCustomerEmailDomainMutationVariables>;

/**
 * __useCreateCustomerEmailDomainMutation__
 *
 * To run a mutation, you first call `useCreateCustomerEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerEmailDomainMutation, { data, loading, error }] = useCreateCustomerEmailDomainMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      emailDomain: // value for 'emailDomain'
 *   },
 * });
 */
export function useCreateCustomerEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerEmailDomainMutation, CreateCustomerEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerEmailDomainMutation, CreateCustomerEmailDomainMutationVariables>(CreateCustomerEmailDomainDocument, options);
      }
export type CreateCustomerEmailDomainMutationHookResult = ReturnType<typeof useCreateCustomerEmailDomainMutation>;
export type CreateCustomerEmailDomainMutationResult = Apollo.MutationResult<CreateCustomerEmailDomainMutation>;
export type CreateCustomerEmailDomainMutationOptions = Apollo.BaseMutationOptions<CreateCustomerEmailDomainMutation, CreateCustomerEmailDomainMutationVariables>;
export const CreateOrReplaceFeatureFlagsDocument = gql`
    mutation createOrReplaceFeatureFlags($featureFlags: FeatureFlagsInput!) {
  createOrReplaceFeatureFlags(featureFlags: $featureFlags)
}
    `;
export type CreateOrReplaceFeatureFlagsMutationFn = Apollo.MutationFunction<CreateOrReplaceFeatureFlagsMutation, CreateOrReplaceFeatureFlagsMutationVariables>;

/**
 * __useCreateOrReplaceFeatureFlagsMutation__
 *
 * To run a mutation, you first call `useCreateOrReplaceFeatureFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrReplaceFeatureFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrReplaceFeatureFlagsMutation, { data, loading, error }] = useCreateOrReplaceFeatureFlagsMutation({
 *   variables: {
 *      featureFlags: // value for 'featureFlags'
 *   },
 * });
 */
export function useCreateOrReplaceFeatureFlagsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrReplaceFeatureFlagsMutation, CreateOrReplaceFeatureFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrReplaceFeatureFlagsMutation, CreateOrReplaceFeatureFlagsMutationVariables>(CreateOrReplaceFeatureFlagsDocument, options);
      }
export type CreateOrReplaceFeatureFlagsMutationHookResult = ReturnType<typeof useCreateOrReplaceFeatureFlagsMutation>;
export type CreateOrReplaceFeatureFlagsMutationResult = Apollo.MutationResult<CreateOrReplaceFeatureFlagsMutation>;
export type CreateOrReplaceFeatureFlagsMutationOptions = Apollo.BaseMutationOptions<CreateOrReplaceFeatureFlagsMutation, CreateOrReplaceFeatureFlagsMutationVariables>;
export const DeleteCustomerEmailDomainDocument = gql`
    mutation DeleteCustomerEmailDomain($customerId: String!, $emailDomain: String!) {
  deleteCustomerEmailDomain(customerId: $customerId, emailDomain: $emailDomain) {
    id
    emailDomains
  }
}
    `;
export type DeleteCustomerEmailDomainMutationFn = Apollo.MutationFunction<DeleteCustomerEmailDomainMutation, DeleteCustomerEmailDomainMutationVariables>;

/**
 * __useDeleteCustomerEmailDomainMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerEmailDomainMutation, { data, loading, error }] = useDeleteCustomerEmailDomainMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      emailDomain: // value for 'emailDomain'
 *   },
 * });
 */
export function useDeleteCustomerEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerEmailDomainMutation, DeleteCustomerEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerEmailDomainMutation, DeleteCustomerEmailDomainMutationVariables>(DeleteCustomerEmailDomainDocument, options);
      }
export type DeleteCustomerEmailDomainMutationHookResult = ReturnType<typeof useDeleteCustomerEmailDomainMutation>;
export type DeleteCustomerEmailDomainMutationResult = Apollo.MutationResult<DeleteCustomerEmailDomainMutation>;
export type DeleteCustomerEmailDomainMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerEmailDomainMutation, DeleteCustomerEmailDomainMutationVariables>;
export const ExecuteMyLayerChangeSetDocument = gql`
    mutation ExecuteMyLayerChangeSet($layerId: String!, $layerChangeSet: LayerChangeSetInput!) {
  executeMyLayerChangeSet(layerId: $layerId, layerChangeSet: $layerChangeSet) {
    id
    rows {
      id
      createdAt
      createdBy
      source
      adjustmentId
      adjustmentLevel
      periodStart
      periodEnd
      value
    }
  }
}
    `;
export type ExecuteMyLayerChangeSetMutationFn = Apollo.MutationFunction<ExecuteMyLayerChangeSetMutation, ExecuteMyLayerChangeSetMutationVariables>;

/**
 * __useExecuteMyLayerChangeSetMutation__
 *
 * To run a mutation, you first call `useExecuteMyLayerChangeSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteMyLayerChangeSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeMyLayerChangeSetMutation, { data, loading, error }] = useExecuteMyLayerChangeSetMutation({
 *   variables: {
 *      layerId: // value for 'layerId'
 *      layerChangeSet: // value for 'layerChangeSet'
 *   },
 * });
 */
export function useExecuteMyLayerChangeSetMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteMyLayerChangeSetMutation, ExecuteMyLayerChangeSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteMyLayerChangeSetMutation, ExecuteMyLayerChangeSetMutationVariables>(ExecuteMyLayerChangeSetDocument, options);
      }
export type ExecuteMyLayerChangeSetMutationHookResult = ReturnType<typeof useExecuteMyLayerChangeSetMutation>;
export type ExecuteMyLayerChangeSetMutationResult = Apollo.MutationResult<ExecuteMyLayerChangeSetMutation>;
export type ExecuteMyLayerChangeSetMutationOptions = Apollo.BaseMutationOptions<ExecuteMyLayerChangeSetMutation, ExecuteMyLayerChangeSetMutationVariables>;
export const GetAllCustomersDocument = gql`
    query GetAllCustomers {
  getAllCustomers {
    name
    id
  }
}
    `;

/**
 * __useGetAllCustomersQuery__
 *
 * To run a query within a React component, call `useGetAllCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCustomersQuery, GetAllCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCustomersQuery, GetAllCustomersQueryVariables>(GetAllCustomersDocument, options);
      }
export function useGetAllCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCustomersQuery, GetAllCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCustomersQuery, GetAllCustomersQueryVariables>(GetAllCustomersDocument, options);
        }
export function useGetAllCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCustomersQuery, GetAllCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCustomersQuery, GetAllCustomersQueryVariables>(GetAllCustomersDocument, options);
        }
export type GetAllCustomersQueryHookResult = ReturnType<typeof useGetAllCustomersQuery>;
export type GetAllCustomersLazyQueryHookResult = ReturnType<typeof useGetAllCustomersLazyQuery>;
export type GetAllCustomersSuspenseQueryHookResult = ReturnType<typeof useGetAllCustomersSuspenseQuery>;
export type GetAllCustomersQueryResult = Apollo.QueryResult<GetAllCustomersQuery, GetAllCustomersQueryVariables>;
export const GetAllMyEngineSettingsDocument = gql`
    query GetAllMyEngineSettings {
  getAllMyEngineSettings {
    id
    name
    version
    default
    json
  }
}
    `;

/**
 * __useGetAllMyEngineSettingsQuery__
 *
 * To run a query within a React component, call `useGetAllMyEngineSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyEngineSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyEngineSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMyEngineSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMyEngineSettingsQuery, GetAllMyEngineSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMyEngineSettingsQuery, GetAllMyEngineSettingsQueryVariables>(GetAllMyEngineSettingsDocument, options);
      }
export function useGetAllMyEngineSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMyEngineSettingsQuery, GetAllMyEngineSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMyEngineSettingsQuery, GetAllMyEngineSettingsQueryVariables>(GetAllMyEngineSettingsDocument, options);
        }
export function useGetAllMyEngineSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMyEngineSettingsQuery, GetAllMyEngineSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMyEngineSettingsQuery, GetAllMyEngineSettingsQueryVariables>(GetAllMyEngineSettingsDocument, options);
        }
export type GetAllMyEngineSettingsQueryHookResult = ReturnType<typeof useGetAllMyEngineSettingsQuery>;
export type GetAllMyEngineSettingsLazyQueryHookResult = ReturnType<typeof useGetAllMyEngineSettingsLazyQuery>;
export type GetAllMyEngineSettingsSuspenseQueryHookResult = ReturnType<typeof useGetAllMyEngineSettingsSuspenseQuery>;
export type GetAllMyEngineSettingsQueryResult = Apollo.QueryResult<GetAllMyEngineSettingsQuery, GetAllMyEngineSettingsQueryVariables>;
export const GetCustomerDocument = gql`
    query GetCustomer($customerId: String!) {
  getCustomer(customerId: $customerId) {
    name
    id
    features
    emailDomains
    defaultRole
  }
}
    `;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables> & ({ variables: GetCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export function useGetCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetLatestRunsDocument = gql`
    query GetLatestRuns {
  getLatestRuns {
    id
    runSettings {
      inputId
      workflowId
      settingsNameAndVersion
      runAttemptId
    }
    status
    createdAt
    updatedAt
    initiatedBy
    name
    description
    customerId
  }
}
    `;

/**
 * __useGetLatestRunsQuery__
 *
 * To run a query within a React component, call `useGetLatestRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestRunsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestRunsQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestRunsQuery, GetLatestRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestRunsQuery, GetLatestRunsQueryVariables>(GetLatestRunsDocument, options);
      }
export function useGetLatestRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestRunsQuery, GetLatestRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestRunsQuery, GetLatestRunsQueryVariables>(GetLatestRunsDocument, options);
        }
export function useGetLatestRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestRunsQuery, GetLatestRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestRunsQuery, GetLatestRunsQueryVariables>(GetLatestRunsDocument, options);
        }
export type GetLatestRunsQueryHookResult = ReturnType<typeof useGetLatestRunsQuery>;
export type GetLatestRunsLazyQueryHookResult = ReturnType<typeof useGetLatestRunsLazyQuery>;
export type GetLatestRunsSuspenseQueryHookResult = ReturnType<typeof useGetLatestRunsSuspenseQuery>;
export type GetLatestRunsQueryResult = Apollo.QueryResult<GetLatestRunsQuery, GetLatestRunsQueryVariables>;
export const GetMyCustomerDocument = gql`
    query GetMyCustomer {
  getMyCustomer {
    name
    id
    features
    ej2License
    muiLicense
    defaultEngineSettingName
    defaultEngineSettingVersion
    forecastLockedToRunId
    preloadDatasets {
      viewDatasetTransform
      paramsJSON
    }
  }
}
    `;

/**
 * __useGetMyCustomerQuery__
 *
 * To run a query within a React component, call `useGetMyCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCustomerQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCustomerQuery, GetMyCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCustomerQuery, GetMyCustomerQueryVariables>(GetMyCustomerDocument, options);
      }
export function useGetMyCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCustomerQuery, GetMyCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCustomerQuery, GetMyCustomerQueryVariables>(GetMyCustomerDocument, options);
        }
export function useGetMyCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCustomerQuery, GetMyCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCustomerQuery, GetMyCustomerQueryVariables>(GetMyCustomerDocument, options);
        }
export type GetMyCustomerQueryHookResult = ReturnType<typeof useGetMyCustomerQuery>;
export type GetMyCustomerLazyQueryHookResult = ReturnType<typeof useGetMyCustomerLazyQuery>;
export type GetMyCustomerSuspenseQueryHookResult = ReturnType<typeof useGetMyCustomerSuspenseQuery>;
export type GetMyCustomerQueryResult = Apollo.QueryResult<GetMyCustomerQuery, GetMyCustomerQueryVariables>;
export const GetMyDataFileDownloadUrlDocument = gql`
    query GetMyDataFileDownloadUrl($runSettings: MyRunSettingsInput!, $dataName: String!, $fileFormat: String!) {
  getMyDataFileDownloadUrl(
    runSettings: $runSettings
    dataName: $dataName
    fileFormat: $fileFormat
  )
}
    `;

/**
 * __useGetMyDataFileDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetMyDataFileDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDataFileDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDataFileDownloadUrlQuery({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      dataName: // value for 'dataName'
 *      fileFormat: // value for 'fileFormat'
 *   },
 * });
 */
export function useGetMyDataFileDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyDataFileDownloadUrlQuery, GetMyDataFileDownloadUrlQueryVariables> & ({ variables: GetMyDataFileDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDataFileDownloadUrlQuery, GetMyDataFileDownloadUrlQueryVariables>(GetMyDataFileDownloadUrlDocument, options);
      }
export function useGetMyDataFileDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDataFileDownloadUrlQuery, GetMyDataFileDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDataFileDownloadUrlQuery, GetMyDataFileDownloadUrlQueryVariables>(GetMyDataFileDownloadUrlDocument, options);
        }
export function useGetMyDataFileDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyDataFileDownloadUrlQuery, GetMyDataFileDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDataFileDownloadUrlQuery, GetMyDataFileDownloadUrlQueryVariables>(GetMyDataFileDownloadUrlDocument, options);
        }
export type GetMyDataFileDownloadUrlQueryHookResult = ReturnType<typeof useGetMyDataFileDownloadUrlQuery>;
export type GetMyDataFileDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetMyDataFileDownloadUrlLazyQuery>;
export type GetMyDataFileDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyDataFileDownloadUrlSuspenseQuery>;
export type GetMyDataFileDownloadUrlQueryResult = Apollo.QueryResult<GetMyDataFileDownloadUrlQuery, GetMyDataFileDownloadUrlQueryVariables>;
export const GetMyDataFileOverrideUploadUrlDocument = gql`
    query GetMyDataFileOverrideUploadUrl($runSettings: MyRunSettingsInput!, $dataName: String!, $fileFormat: String!) {
  getMyDataFileOverrideUploadUrl(
    runSettings: $runSettings
    dataName: $dataName
    fileFormat: $fileFormat
  )
}
    `;

/**
 * __useGetMyDataFileOverrideUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetMyDataFileOverrideUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDataFileOverrideUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDataFileOverrideUploadUrlQuery({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      dataName: // value for 'dataName'
 *      fileFormat: // value for 'fileFormat'
 *   },
 * });
 */
export function useGetMyDataFileOverrideUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyDataFileOverrideUploadUrlQuery, GetMyDataFileOverrideUploadUrlQueryVariables> & ({ variables: GetMyDataFileOverrideUploadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDataFileOverrideUploadUrlQuery, GetMyDataFileOverrideUploadUrlQueryVariables>(GetMyDataFileOverrideUploadUrlDocument, options);
      }
export function useGetMyDataFileOverrideUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDataFileOverrideUploadUrlQuery, GetMyDataFileOverrideUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDataFileOverrideUploadUrlQuery, GetMyDataFileOverrideUploadUrlQueryVariables>(GetMyDataFileOverrideUploadUrlDocument, options);
        }
export function useGetMyDataFileOverrideUploadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyDataFileOverrideUploadUrlQuery, GetMyDataFileOverrideUploadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDataFileOverrideUploadUrlQuery, GetMyDataFileOverrideUploadUrlQueryVariables>(GetMyDataFileOverrideUploadUrlDocument, options);
        }
export type GetMyDataFileOverrideUploadUrlQueryHookResult = ReturnType<typeof useGetMyDataFileOverrideUploadUrlQuery>;
export type GetMyDataFileOverrideUploadUrlLazyQueryHookResult = ReturnType<typeof useGetMyDataFileOverrideUploadUrlLazyQuery>;
export type GetMyDataFileOverrideUploadUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyDataFileOverrideUploadUrlSuspenseQuery>;
export type GetMyDataFileOverrideUploadUrlQueryResult = Apollo.QueryResult<GetMyDataFileOverrideUploadUrlQuery, GetMyDataFileOverrideUploadUrlQueryVariables>;
export const GetMyDataFileWithOverrideDownloadUrlDocument = gql`
    query GetMyDataFileWithOverrideDownloadUrl($runSettings: MyRunSettingsInput!, $dataName: String!, $fileFormat: String!) {
  getMyDataFileWithOverrideDownloadUrl(
    runSettings: $runSettings
    dataName: $dataName
    fileFormat: $fileFormat
  )
}
    `;

/**
 * __useGetMyDataFileWithOverrideDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetMyDataFileWithOverrideDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDataFileWithOverrideDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDataFileWithOverrideDownloadUrlQuery({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      dataName: // value for 'dataName'
 *      fileFormat: // value for 'fileFormat'
 *   },
 * });
 */
export function useGetMyDataFileWithOverrideDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMyDataFileWithOverrideDownloadUrlQuery, GetMyDataFileWithOverrideDownloadUrlQueryVariables> & ({ variables: GetMyDataFileWithOverrideDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDataFileWithOverrideDownloadUrlQuery, GetMyDataFileWithOverrideDownloadUrlQueryVariables>(GetMyDataFileWithOverrideDownloadUrlDocument, options);
      }
export function useGetMyDataFileWithOverrideDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDataFileWithOverrideDownloadUrlQuery, GetMyDataFileWithOverrideDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDataFileWithOverrideDownloadUrlQuery, GetMyDataFileWithOverrideDownloadUrlQueryVariables>(GetMyDataFileWithOverrideDownloadUrlDocument, options);
        }
export function useGetMyDataFileWithOverrideDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyDataFileWithOverrideDownloadUrlQuery, GetMyDataFileWithOverrideDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyDataFileWithOverrideDownloadUrlQuery, GetMyDataFileWithOverrideDownloadUrlQueryVariables>(GetMyDataFileWithOverrideDownloadUrlDocument, options);
        }
export type GetMyDataFileWithOverrideDownloadUrlQueryHookResult = ReturnType<typeof useGetMyDataFileWithOverrideDownloadUrlQuery>;
export type GetMyDataFileWithOverrideDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetMyDataFileWithOverrideDownloadUrlLazyQuery>;
export type GetMyDataFileWithOverrideDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetMyDataFileWithOverrideDownloadUrlSuspenseQuery>;
export type GetMyDataFileWithOverrideDownloadUrlQueryResult = Apollo.QueryResult<GetMyDataFileWithOverrideDownloadUrlQuery, GetMyDataFileWithOverrideDownloadUrlQueryVariables>;
export const GetMyEditedLayerDocument = gql`
    query GetMyEditedLayer($id: String!) {
  getMyEditedLayer(id: $id) {
    id
    rows {
      id
      createdAt
      createdBy
      source
      adjustmentId
      adjustmentLevel
      periodStart
      periodEnd
      value
    }
  }
}
    `;

/**
 * __useGetMyEditedLayerQuery__
 *
 * To run a query within a React component, call `useGetMyEditedLayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEditedLayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEditedLayerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyEditedLayerQuery(baseOptions: Apollo.QueryHookOptions<GetMyEditedLayerQuery, GetMyEditedLayerQueryVariables> & ({ variables: GetMyEditedLayerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEditedLayerQuery, GetMyEditedLayerQueryVariables>(GetMyEditedLayerDocument, options);
      }
export function useGetMyEditedLayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEditedLayerQuery, GetMyEditedLayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEditedLayerQuery, GetMyEditedLayerQueryVariables>(GetMyEditedLayerDocument, options);
        }
export function useGetMyEditedLayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyEditedLayerQuery, GetMyEditedLayerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyEditedLayerQuery, GetMyEditedLayerQueryVariables>(GetMyEditedLayerDocument, options);
        }
export type GetMyEditedLayerQueryHookResult = ReturnType<typeof useGetMyEditedLayerQuery>;
export type GetMyEditedLayerLazyQueryHookResult = ReturnType<typeof useGetMyEditedLayerLazyQuery>;
export type GetMyEditedLayerSuspenseQueryHookResult = ReturnType<typeof useGetMyEditedLayerSuspenseQuery>;
export type GetMyEditedLayerQueryResult = Apollo.QueryResult<GetMyEditedLayerQuery, GetMyEditedLayerQueryVariables>;
export const GetMyEngineSettingsDocument = gql`
    query GetMyEngineSettings($settingsName: String!, $settingsVersion: String!) {
  getMyEngineSettings(
    settingsName: $settingsName
    settingsVersion: $settingsVersion
  ) {
    id
    name
    version
    default
    json
    layer {
      id
      rows {
        id
        createdAt
        createdBy
        source
        adjustmentId
        adjustmentLevel
        periodStart
        periodEnd
        value
      }
    }
  }
}
    `;

/**
 * __useGetMyEngineSettingsQuery__
 *
 * To run a query within a React component, call `useGetMyEngineSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEngineSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEngineSettingsQuery({
 *   variables: {
 *      settingsName: // value for 'settingsName'
 *      settingsVersion: // value for 'settingsVersion'
 *   },
 * });
 */
export function useGetMyEngineSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetMyEngineSettingsQuery, GetMyEngineSettingsQueryVariables> & ({ variables: GetMyEngineSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEngineSettingsQuery, GetMyEngineSettingsQueryVariables>(GetMyEngineSettingsDocument, options);
      }
export function useGetMyEngineSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEngineSettingsQuery, GetMyEngineSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEngineSettingsQuery, GetMyEngineSettingsQueryVariables>(GetMyEngineSettingsDocument, options);
        }
export function useGetMyEngineSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyEngineSettingsQuery, GetMyEngineSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyEngineSettingsQuery, GetMyEngineSettingsQueryVariables>(GetMyEngineSettingsDocument, options);
        }
export type GetMyEngineSettingsQueryHookResult = ReturnType<typeof useGetMyEngineSettingsQuery>;
export type GetMyEngineSettingsLazyQueryHookResult = ReturnType<typeof useGetMyEngineSettingsLazyQuery>;
export type GetMyEngineSettingsSuspenseQueryHookResult = ReturnType<typeof useGetMyEngineSettingsSuspenseQuery>;
export type GetMyEngineSettingsQueryResult = Apollo.QueryResult<GetMyEngineSettingsQuery, GetMyEngineSettingsQueryVariables>;
export const GetMyInputDatastructureNamesDocument = gql`
    query GetMyInputDatastructureNames($inputId: String!) {
  getMyInputDatastructureNames(inputId: $inputId)
}
    `;

/**
 * __useGetMyInputDatastructureNamesQuery__
 *
 * To run a query within a React component, call `useGetMyInputDatastructureNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyInputDatastructureNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyInputDatastructureNamesQuery({
 *   variables: {
 *      inputId: // value for 'inputId'
 *   },
 * });
 */
export function useGetMyInputDatastructureNamesQuery(baseOptions: Apollo.QueryHookOptions<GetMyInputDatastructureNamesQuery, GetMyInputDatastructureNamesQueryVariables> & ({ variables: GetMyInputDatastructureNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyInputDatastructureNamesQuery, GetMyInputDatastructureNamesQueryVariables>(GetMyInputDatastructureNamesDocument, options);
      }
export function useGetMyInputDatastructureNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyInputDatastructureNamesQuery, GetMyInputDatastructureNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyInputDatastructureNamesQuery, GetMyInputDatastructureNamesQueryVariables>(GetMyInputDatastructureNamesDocument, options);
        }
export function useGetMyInputDatastructureNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyInputDatastructureNamesQuery, GetMyInputDatastructureNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyInputDatastructureNamesQuery, GetMyInputDatastructureNamesQueryVariables>(GetMyInputDatastructureNamesDocument, options);
        }
export type GetMyInputDatastructureNamesQueryHookResult = ReturnType<typeof useGetMyInputDatastructureNamesQuery>;
export type GetMyInputDatastructureNamesLazyQueryHookResult = ReturnType<typeof useGetMyInputDatastructureNamesLazyQuery>;
export type GetMyInputDatastructureNamesSuspenseQueryHookResult = ReturnType<typeof useGetMyInputDatastructureNamesSuspenseQuery>;
export type GetMyInputDatastructureNamesQueryResult = Apollo.QueryResult<GetMyInputDatastructureNamesQuery, GetMyInputDatastructureNamesQueryVariables>;
export const GetMyInputIdsDocument = gql`
    query getMyInputIds {
  getMyInputIds
}
    `;

/**
 * __useGetMyInputIdsQuery__
 *
 * To run a query within a React component, call `useGetMyInputIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyInputIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyInputIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyInputIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyInputIdsQuery, GetMyInputIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyInputIdsQuery, GetMyInputIdsQueryVariables>(GetMyInputIdsDocument, options);
      }
export function useGetMyInputIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyInputIdsQuery, GetMyInputIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyInputIdsQuery, GetMyInputIdsQueryVariables>(GetMyInputIdsDocument, options);
        }
export function useGetMyInputIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyInputIdsQuery, GetMyInputIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyInputIdsQuery, GetMyInputIdsQueryVariables>(GetMyInputIdsDocument, options);
        }
export type GetMyInputIdsQueryHookResult = ReturnType<typeof useGetMyInputIdsQuery>;
export type GetMyInputIdsLazyQueryHookResult = ReturnType<typeof useGetMyInputIdsLazyQuery>;
export type GetMyInputIdsSuspenseQueryHookResult = ReturnType<typeof useGetMyInputIdsSuspenseQuery>;
export type GetMyInputIdsQueryResult = Apollo.QueryResult<GetMyInputIdsQuery, GetMyInputIdsQueryVariables>;
export const GetMyOutputDatastructureNamesDocument = gql`
    query GetMyOutputDatastructureNames($outputId: String!) {
  getMyOutputDatastructureNames(outputId: $outputId)
}
    `;

/**
 * __useGetMyOutputDatastructureNamesQuery__
 *
 * To run a query within a React component, call `useGetMyOutputDatastructureNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOutputDatastructureNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOutputDatastructureNamesQuery({
 *   variables: {
 *      outputId: // value for 'outputId'
 *   },
 * });
 */
export function useGetMyOutputDatastructureNamesQuery(baseOptions: Apollo.QueryHookOptions<GetMyOutputDatastructureNamesQuery, GetMyOutputDatastructureNamesQueryVariables> & ({ variables: GetMyOutputDatastructureNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOutputDatastructureNamesQuery, GetMyOutputDatastructureNamesQueryVariables>(GetMyOutputDatastructureNamesDocument, options);
      }
export function useGetMyOutputDatastructureNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOutputDatastructureNamesQuery, GetMyOutputDatastructureNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOutputDatastructureNamesQuery, GetMyOutputDatastructureNamesQueryVariables>(GetMyOutputDatastructureNamesDocument, options);
        }
export function useGetMyOutputDatastructureNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyOutputDatastructureNamesQuery, GetMyOutputDatastructureNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyOutputDatastructureNamesQuery, GetMyOutputDatastructureNamesQueryVariables>(GetMyOutputDatastructureNamesDocument, options);
        }
export type GetMyOutputDatastructureNamesQueryHookResult = ReturnType<typeof useGetMyOutputDatastructureNamesQuery>;
export type GetMyOutputDatastructureNamesLazyQueryHookResult = ReturnType<typeof useGetMyOutputDatastructureNamesLazyQuery>;
export type GetMyOutputDatastructureNamesSuspenseQueryHookResult = ReturnType<typeof useGetMyOutputDatastructureNamesSuspenseQuery>;
export type GetMyOutputDatastructureNamesQueryResult = Apollo.QueryResult<GetMyOutputDatastructureNamesQuery, GetMyOutputDatastructureNamesQueryVariables>;
export const GetMyRunComparisonSummaryDocument = gql`
    query GetMyRunComparisonSummary($runSettings1: MyRunSettingsInput!, $runSettings2: MyRunSettingsInput!) {
  getMyRunComparisonSummary(
    runSettings1: $runSettings1
    runSettings2: $runSettings2
  )
}
    `;

/**
 * __useGetMyRunComparisonSummaryQuery__
 *
 * To run a query within a React component, call `useGetMyRunComparisonSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRunComparisonSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRunComparisonSummaryQuery({
 *   variables: {
 *      runSettings1: // value for 'runSettings1'
 *      runSettings2: // value for 'runSettings2'
 *   },
 * });
 */
export function useGetMyRunComparisonSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetMyRunComparisonSummaryQuery, GetMyRunComparisonSummaryQueryVariables> & ({ variables: GetMyRunComparisonSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRunComparisonSummaryQuery, GetMyRunComparisonSummaryQueryVariables>(GetMyRunComparisonSummaryDocument, options);
      }
export function useGetMyRunComparisonSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRunComparisonSummaryQuery, GetMyRunComparisonSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRunComparisonSummaryQuery, GetMyRunComparisonSummaryQueryVariables>(GetMyRunComparisonSummaryDocument, options);
        }
export function useGetMyRunComparisonSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyRunComparisonSummaryQuery, GetMyRunComparisonSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyRunComparisonSummaryQuery, GetMyRunComparisonSummaryQueryVariables>(GetMyRunComparisonSummaryDocument, options);
        }
export type GetMyRunComparisonSummaryQueryHookResult = ReturnType<typeof useGetMyRunComparisonSummaryQuery>;
export type GetMyRunComparisonSummaryLazyQueryHookResult = ReturnType<typeof useGetMyRunComparisonSummaryLazyQuery>;
export type GetMyRunComparisonSummarySuspenseQueryHookResult = ReturnType<typeof useGetMyRunComparisonSummarySuspenseQuery>;
export type GetMyRunComparisonSummaryQueryResult = Apollo.QueryResult<GetMyRunComparisonSummaryQuery, GetMyRunComparisonSummaryQueryVariables>;
export const GetMyRunsDocument = gql`
    query GetMyRuns {
  getMyRuns {
    id
    runSettings {
      inputId
      organizationId
      workflowId
      settingsNameAndVersion
      runAttemptId
    }
    status
    createdAt
    updatedAt
    stepIds
    initiatedBy
    name
    description
    atStep
    totalSteps
    engineInProgress
    comparisonWithPreviousRunJson
  }
}
    `;

/**
 * __useGetMyRunsQuery__
 *
 * To run a query within a React component, call `useGetMyRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRunsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyRunsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyRunsQuery, GetMyRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRunsQuery, GetMyRunsQueryVariables>(GetMyRunsDocument, options);
      }
export function useGetMyRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRunsQuery, GetMyRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRunsQuery, GetMyRunsQueryVariables>(GetMyRunsDocument, options);
        }
export function useGetMyRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyRunsQuery, GetMyRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyRunsQuery, GetMyRunsQueryVariables>(GetMyRunsDocument, options);
        }
export type GetMyRunsQueryHookResult = ReturnType<typeof useGetMyRunsQuery>;
export type GetMyRunsLazyQueryHookResult = ReturnType<typeof useGetMyRunsLazyQuery>;
export type GetMyRunsSuspenseQueryHookResult = ReturnType<typeof useGetMyRunsSuspenseQuery>;
export type GetMyRunsQueryResult = Apollo.QueryResult<GetMyRunsQuery, GetMyRunsQueryVariables>;
export const GetMyTeamMembersDocument = gql`
    query GetMyTeamMembers {
  getMyTeamMembers {
    id
    name
    email
    role
    customerId
    status
  }
}
    `;

/**
 * __useGetMyTeamMembersQuery__
 *
 * To run a query within a React component, call `useGetMyTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
      }
export function useGetMyTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
        }
export function useGetMyTeamMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>(GetMyTeamMembersDocument, options);
        }
export type GetMyTeamMembersQueryHookResult = ReturnType<typeof useGetMyTeamMembersQuery>;
export type GetMyTeamMembersLazyQueryHookResult = ReturnType<typeof useGetMyTeamMembersLazyQuery>;
export type GetMyTeamMembersSuspenseQueryHookResult = ReturnType<typeof useGetMyTeamMembersSuspenseQuery>;
export type GetMyTeamMembersQueryResult = Apollo.QueryResult<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>;
export const MakeMyEngineSettingsDefaultDocument = gql`
    mutation MakeMyEngineSettingsDefault($settingsName: String!, $settingsVersion: String) {
  makeMyEngineSettingsDefault(
    settingsName: $settingsName
    settingsVersion: $settingsVersion
  ) {
    defaultEngineSettingName
    defaultEngineSettingVersion
  }
}
    `;
export type MakeMyEngineSettingsDefaultMutationFn = Apollo.MutationFunction<MakeMyEngineSettingsDefaultMutation, MakeMyEngineSettingsDefaultMutationVariables>;

/**
 * __useMakeMyEngineSettingsDefaultMutation__
 *
 * To run a mutation, you first call `useMakeMyEngineSettingsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeMyEngineSettingsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeMyEngineSettingsDefaultMutation, { data, loading, error }] = useMakeMyEngineSettingsDefaultMutation({
 *   variables: {
 *      settingsName: // value for 'settingsName'
 *      settingsVersion: // value for 'settingsVersion'
 *   },
 * });
 */
export function useMakeMyEngineSettingsDefaultMutation(baseOptions?: Apollo.MutationHookOptions<MakeMyEngineSettingsDefaultMutation, MakeMyEngineSettingsDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeMyEngineSettingsDefaultMutation, MakeMyEngineSettingsDefaultMutationVariables>(MakeMyEngineSettingsDefaultDocument, options);
      }
export type MakeMyEngineSettingsDefaultMutationHookResult = ReturnType<typeof useMakeMyEngineSettingsDefaultMutation>;
export type MakeMyEngineSettingsDefaultMutationResult = Apollo.MutationResult<MakeMyEngineSettingsDefaultMutation>;
export type MakeMyEngineSettingsDefaultMutationOptions = Apollo.BaseMutationOptions<MakeMyEngineSettingsDefaultMutation, MakeMyEngineSettingsDefaultMutationVariables>;
export const RerunMyStepDocument = gql`
    mutation RerunMyStep($runSettings: MyRunSettingsInput!, $stepId: String!) {
  rerunMyStep(runSettings: $runSettings, stepId: $stepId)
}
    `;
export type RerunMyStepMutationFn = Apollo.MutationFunction<RerunMyStepMutation, RerunMyStepMutationVariables>;

/**
 * __useRerunMyStepMutation__
 *
 * To run a mutation, you first call `useRerunMyStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunMyStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunMyStepMutation, { data, loading, error }] = useRerunMyStepMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      stepId: // value for 'stepId'
 *   },
 * });
 */
export function useRerunMyStepMutation(baseOptions?: Apollo.MutationHookOptions<RerunMyStepMutation, RerunMyStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RerunMyStepMutation, RerunMyStepMutationVariables>(RerunMyStepDocument, options);
      }
export type RerunMyStepMutationHookResult = ReturnType<typeof useRerunMyStepMutation>;
export type RerunMyStepMutationResult = Apollo.MutationResult<RerunMyStepMutation>;
export type RerunMyStepMutationOptions = Apollo.BaseMutationOptions<RerunMyStepMutation, RerunMyStepMutationVariables>;
export const RetryMyRunDocument = gql`
    mutation RetryMyRun($runSettings: RunInput!) {
  retryMyRun(runSettings: $runSettings)
}
    `;
export type RetryMyRunMutationFn = Apollo.MutationFunction<RetryMyRunMutation, RetryMyRunMutationVariables>;

/**
 * __useRetryMyRunMutation__
 *
 * To run a mutation, you first call `useRetryMyRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryMyRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryMyRunMutation, { data, loading, error }] = useRetryMyRunMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useRetryMyRunMutation(baseOptions?: Apollo.MutationHookOptions<RetryMyRunMutation, RetryMyRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryMyRunMutation, RetryMyRunMutationVariables>(RetryMyRunDocument, options);
      }
export type RetryMyRunMutationHookResult = ReturnType<typeof useRetryMyRunMutation>;
export type RetryMyRunMutationResult = Apollo.MutationResult<RetryMyRunMutation>;
export type RetryMyRunMutationOptions = Apollo.BaseMutationOptions<RetryMyRunMutation, RetryMyRunMutationVariables>;
export const SaveApprovedPOsDocument = gql`
    mutation SaveApprovedPOs($runSettings: MyRunSettingsInput!, $poAction: PoActionInput!) {
  saveApprovedPOs(runSettings: $runSettings, poAction: $poAction)
}
    `;
export type SaveApprovedPOsMutationFn = Apollo.MutationFunction<SaveApprovedPOsMutation, SaveApprovedPOsMutationVariables>;

/**
 * __useSaveApprovedPOsMutation__
 *
 * To run a mutation, you first call `useSaveApprovedPOsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveApprovedPOsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveApprovedPOsMutation, { data, loading, error }] = useSaveApprovedPOsMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      poAction: // value for 'poAction'
 *   },
 * });
 */
export function useSaveApprovedPOsMutation(baseOptions?: Apollo.MutationHookOptions<SaveApprovedPOsMutation, SaveApprovedPOsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveApprovedPOsMutation, SaveApprovedPOsMutationVariables>(SaveApprovedPOsDocument, options);
      }
export type SaveApprovedPOsMutationHookResult = ReturnType<typeof useSaveApprovedPOsMutation>;
export type SaveApprovedPOsMutationResult = Apollo.MutationResult<SaveApprovedPOsMutation>;
export type SaveApprovedPOsMutationOptions = Apollo.BaseMutationOptions<SaveApprovedPOsMutation, SaveApprovedPOsMutationVariables>;
export const SaveApprovedPOsBatchDocument = gql`
    mutation SaveApprovedPOsBatch($runSettings: MyRunSettingsInput!, $actions: [PoActionInput!]!) {
  saveApprovedPOsBatch(runSettings: $runSettings, actions: $actions) {
    s3Key
    appliedCount
  }
}
    `;
export type SaveApprovedPOsBatchMutationFn = Apollo.MutationFunction<SaveApprovedPOsBatchMutation, SaveApprovedPOsBatchMutationVariables>;

/**
 * __useSaveApprovedPOsBatchMutation__
 *
 * To run a mutation, you first call `useSaveApprovedPOsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveApprovedPOsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveApprovedPOsBatchMutation, { data, loading, error }] = useSaveApprovedPOsBatchMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      actions: // value for 'actions'
 *   },
 * });
 */
export function useSaveApprovedPOsBatchMutation(baseOptions?: Apollo.MutationHookOptions<SaveApprovedPOsBatchMutation, SaveApprovedPOsBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveApprovedPOsBatchMutation, SaveApprovedPOsBatchMutationVariables>(SaveApprovedPOsBatchDocument, options);
      }
export type SaveApprovedPOsBatchMutationHookResult = ReturnType<typeof useSaveApprovedPOsBatchMutation>;
export type SaveApprovedPOsBatchMutationResult = Apollo.MutationResult<SaveApprovedPOsBatchMutation>;
export type SaveApprovedPOsBatchMutationOptions = Apollo.BaseMutationOptions<SaveApprovedPOsBatchMutation, SaveApprovedPOsBatchMutationVariables>;
export const SavePurchasingCalendarOverrideToDefaultSettingsDocument = gql`
    mutation SavePurchasingCalendarOverrideToDefaultSettings($fileContent: String!, $runSettings: UserRunSettingsInput) {
  savePurchasingCalendarOverrideToDefaultSettings(
    fileContent: $fileContent
    runSettings: $runSettings
  ) {
    defaultEngineSettingName
    defaultEngineSettingVersion
  }
}
    `;
export type SavePurchasingCalendarOverrideToDefaultSettingsMutationFn = Apollo.MutationFunction<SavePurchasingCalendarOverrideToDefaultSettingsMutation, SavePurchasingCalendarOverrideToDefaultSettingsMutationVariables>;

/**
 * __useSavePurchasingCalendarOverrideToDefaultSettingsMutation__
 *
 * To run a mutation, you first call `useSavePurchasingCalendarOverrideToDefaultSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePurchasingCalendarOverrideToDefaultSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePurchasingCalendarOverrideToDefaultSettingsMutation, { data, loading, error }] = useSavePurchasingCalendarOverrideToDefaultSettingsMutation({
 *   variables: {
 *      fileContent: // value for 'fileContent'
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useSavePurchasingCalendarOverrideToDefaultSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SavePurchasingCalendarOverrideToDefaultSettingsMutation, SavePurchasingCalendarOverrideToDefaultSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePurchasingCalendarOverrideToDefaultSettingsMutation, SavePurchasingCalendarOverrideToDefaultSettingsMutationVariables>(SavePurchasingCalendarOverrideToDefaultSettingsDocument, options);
      }
export type SavePurchasingCalendarOverrideToDefaultSettingsMutationHookResult = ReturnType<typeof useSavePurchasingCalendarOverrideToDefaultSettingsMutation>;
export type SavePurchasingCalendarOverrideToDefaultSettingsMutationResult = Apollo.MutationResult<SavePurchasingCalendarOverrideToDefaultSettingsMutation>;
export type SavePurchasingCalendarOverrideToDefaultSettingsMutationOptions = Apollo.BaseMutationOptions<SavePurchasingCalendarOverrideToDefaultSettingsMutation, SavePurchasingCalendarOverrideToDefaultSettingsMutationVariables>;
export const SetMyRunDescriptionDocument = gql`
    mutation SetMyRunDescription($runSettings: MyRunSettingsInput!, $description: String!) {
  setMyRunDescription(runSettings: $runSettings, description: $description)
}
    `;
export type SetMyRunDescriptionMutationFn = Apollo.MutationFunction<SetMyRunDescriptionMutation, SetMyRunDescriptionMutationVariables>;

/**
 * __useSetMyRunDescriptionMutation__
 *
 * To run a mutation, you first call `useSetMyRunDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyRunDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyRunDescriptionMutation, { data, loading, error }] = useSetMyRunDescriptionMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useSetMyRunDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<SetMyRunDescriptionMutation, SetMyRunDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyRunDescriptionMutation, SetMyRunDescriptionMutationVariables>(SetMyRunDescriptionDocument, options);
      }
export type SetMyRunDescriptionMutationHookResult = ReturnType<typeof useSetMyRunDescriptionMutation>;
export type SetMyRunDescriptionMutationResult = Apollo.MutationResult<SetMyRunDescriptionMutation>;
export type SetMyRunDescriptionMutationOptions = Apollo.BaseMutationOptions<SetMyRunDescriptionMutation, SetMyRunDescriptionMutationVariables>;
export const SetMyRunNameDocument = gql`
    mutation SetMyRunName($runSettings: MyRunSettingsInput!, $name: String!) {
  setMyRunName(runSettings: $runSettings, name: $name)
}
    `;
export type SetMyRunNameMutationFn = Apollo.MutationFunction<SetMyRunNameMutation, SetMyRunNameMutationVariables>;

/**
 * __useSetMyRunNameMutation__
 *
 * To run a mutation, you first call `useSetMyRunNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyRunNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyRunNameMutation, { data, loading, error }] = useSetMyRunNameMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSetMyRunNameMutation(baseOptions?: Apollo.MutationHookOptions<SetMyRunNameMutation, SetMyRunNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyRunNameMutation, SetMyRunNameMutationVariables>(SetMyRunNameDocument, options);
      }
export type SetMyRunNameMutationHookResult = ReturnType<typeof useSetMyRunNameMutation>;
export type SetMyRunNameMutationResult = Apollo.MutationResult<SetMyRunNameMutation>;
export type SetMyRunNameMutationOptions = Apollo.BaseMutationOptions<SetMyRunNameMutation, SetMyRunNameMutationVariables>;
export const StartMyRecalculatedUserRunDocument = gql`
    mutation StartMyRecalculatedUserRun($runSettings: UserRunSettingsInput!) {
  startMyRecalculatedUserRun(runSettings: $runSettings) {
    runSettings {
      inputId
      workflowId
      settingsNameAndVersion
      runAttemptId
    }
    status
    createdAt
    updatedAt
    stepIds
    initiatedBy
    name
    description
  }
}
    `;
export type StartMyRecalculatedUserRunMutationFn = Apollo.MutationFunction<StartMyRecalculatedUserRunMutation, StartMyRecalculatedUserRunMutationVariables>;

/**
 * __useStartMyRecalculatedUserRunMutation__
 *
 * To run a mutation, you first call `useStartMyRecalculatedUserRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMyRecalculatedUserRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMyRecalculatedUserRunMutation, { data, loading, error }] = useStartMyRecalculatedUserRunMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useStartMyRecalculatedUserRunMutation(baseOptions?: Apollo.MutationHookOptions<StartMyRecalculatedUserRunMutation, StartMyRecalculatedUserRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMyRecalculatedUserRunMutation, StartMyRecalculatedUserRunMutationVariables>(StartMyRecalculatedUserRunDocument, options);
      }
export type StartMyRecalculatedUserRunMutationHookResult = ReturnType<typeof useStartMyRecalculatedUserRunMutation>;
export type StartMyRecalculatedUserRunMutationResult = Apollo.MutationResult<StartMyRecalculatedUserRunMutation>;
export type StartMyRecalculatedUserRunMutationOptions = Apollo.BaseMutationOptions<StartMyRecalculatedUserRunMutation, StartMyRecalculatedUserRunMutationVariables>;
export const StartMyRunDocument = gql`
    mutation StartMyRun($runSettings: MyRunSettingsInput!) {
  startMyRun(runSettings: $runSettings) {
    id
    runSettings {
      inputId
      organizationId
      workflowId
      settingsNameAndVersion
      runAttemptId
    }
    status
    createdAt
    updatedAt
    stepIds
    initiatedBy
    name
    description
    atStep
    totalSteps
    engineInProgress
  }
}
    `;
export type StartMyRunMutationFn = Apollo.MutationFunction<StartMyRunMutation, StartMyRunMutationVariables>;

/**
 * __useStartMyRunMutation__
 *
 * To run a mutation, you first call `useStartMyRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMyRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMyRunMutation, { data, loading, error }] = useStartMyRunMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useStartMyRunMutation(baseOptions?: Apollo.MutationHookOptions<StartMyRunMutation, StartMyRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMyRunMutation, StartMyRunMutationVariables>(StartMyRunDocument, options);
      }
export type StartMyRunMutationHookResult = ReturnType<typeof useStartMyRunMutation>;
export type StartMyRunMutationResult = Apollo.MutationResult<StartMyRunMutation>;
export type StartMyRunMutationOptions = Apollo.BaseMutationOptions<StartMyRunMutation, StartMyRunMutationVariables>;
export const StartMySheetImporterSyncDocument = gql`
    mutation StartMySheetImporterSync {
  startMySheetImporterSync
}
    `;
export type StartMySheetImporterSyncMutationFn = Apollo.MutationFunction<StartMySheetImporterSyncMutation, StartMySheetImporterSyncMutationVariables>;

/**
 * __useStartMySheetImporterSyncMutation__
 *
 * To run a mutation, you first call `useStartMySheetImporterSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMySheetImporterSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMySheetImporterSyncMutation, { data, loading, error }] = useStartMySheetImporterSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartMySheetImporterSyncMutation(baseOptions?: Apollo.MutationHookOptions<StartMySheetImporterSyncMutation, StartMySheetImporterSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMySheetImporterSyncMutation, StartMySheetImporterSyncMutationVariables>(StartMySheetImporterSyncDocument, options);
      }
export type StartMySheetImporterSyncMutationHookResult = ReturnType<typeof useStartMySheetImporterSyncMutation>;
export type StartMySheetImporterSyncMutationResult = Apollo.MutationResult<StartMySheetImporterSyncMutation>;
export type StartMySheetImporterSyncMutationOptions = Apollo.BaseMutationOptions<StartMySheetImporterSyncMutation, StartMySheetImporterSyncMutationVariables>;
export const StartMyUserRunDocument = gql`
    mutation StartMyUserRun($runSettings: UserRunSettingsInput!) {
  startMyUserRun(runSettings: $runSettings) {
    runSettings {
      inputId
      organizationId
      workflowId
      settingsNameAndVersion
      runAttemptId
    }
    status
    createdAt
    updatedAt
    stepIds
    initiatedBy
    name
    description
    atStep
    totalSteps
    engineInProgress
  }
}
    `;
export type StartMyUserRunMutationFn = Apollo.MutationFunction<StartMyUserRunMutation, StartMyUserRunMutationVariables>;

/**
 * __useStartMyUserRunMutation__
 *
 * To run a mutation, you first call `useStartMyUserRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMyUserRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMyUserRunMutation, { data, loading, error }] = useStartMyUserRunMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useStartMyUserRunMutation(baseOptions?: Apollo.MutationHookOptions<StartMyUserRunMutation, StartMyUserRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMyUserRunMutation, StartMyUserRunMutationVariables>(StartMyUserRunDocument, options);
      }
export type StartMyUserRunMutationHookResult = ReturnType<typeof useStartMyUserRunMutation>;
export type StartMyUserRunMutationResult = Apollo.MutationResult<StartMyUserRunMutation>;
export type StartMyUserRunMutationOptions = Apollo.BaseMutationOptions<StartMyUserRunMutation, StartMyUserRunMutationVariables>;
export const StoreMyEditedLayerAsSettingsDocument = gql`
    mutation StoreMyEditedLayerAsSettings($layerId: String!, $settingsName: String!, $settingsVersion: String!) {
  storeMyEditedLayerAsSettings(
    layerId: $layerId
    settingsName: $settingsName
    settingsVersion: $settingsVersion
  ) {
    id
    name
    version
    default
    json
    layer {
      id
      rows {
        id
        createdAt
        createdBy
        source
        adjustmentId
        adjustmentLevel
        periodStart
        periodEnd
        value
      }
    }
  }
}
    `;
export type StoreMyEditedLayerAsSettingsMutationFn = Apollo.MutationFunction<StoreMyEditedLayerAsSettingsMutation, StoreMyEditedLayerAsSettingsMutationVariables>;

/**
 * __useStoreMyEditedLayerAsSettingsMutation__
 *
 * To run a mutation, you first call `useStoreMyEditedLayerAsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMyEditedLayerAsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMyEditedLayerAsSettingsMutation, { data, loading, error }] = useStoreMyEditedLayerAsSettingsMutation({
 *   variables: {
 *      layerId: // value for 'layerId'
 *      settingsName: // value for 'settingsName'
 *      settingsVersion: // value for 'settingsVersion'
 *   },
 * });
 */
export function useStoreMyEditedLayerAsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<StoreMyEditedLayerAsSettingsMutation, StoreMyEditedLayerAsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreMyEditedLayerAsSettingsMutation, StoreMyEditedLayerAsSettingsMutationVariables>(StoreMyEditedLayerAsSettingsDocument, options);
      }
export type StoreMyEditedLayerAsSettingsMutationHookResult = ReturnType<typeof useStoreMyEditedLayerAsSettingsMutation>;
export type StoreMyEditedLayerAsSettingsMutationResult = Apollo.MutationResult<StoreMyEditedLayerAsSettingsMutation>;
export type StoreMyEditedLayerAsSettingsMutationOptions = Apollo.BaseMutationOptions<StoreMyEditedLayerAsSettingsMutation, StoreMyEditedLayerAsSettingsMutationVariables>;
export const StoreMyViewForPreloadDocument = gql`
    mutation StoreMyViewForPreload($datasetName: String!, $transformId: String!, $paramsJSON: String!, $pinName: String, $setAsDefault: Boolean, $oldPinName: String, $deletePinName: String) {
  storeMyViewForPreload(
    datasetName: $datasetName
    transformId: $transformId
    paramsJSON: $paramsJSON
    pinName: $pinName
    setAsDefault: $setAsDefault
    oldPinName: $oldPinName
    deletePinName: $deletePinName
  ) {
    name
    id
    features
    ej2License
    muiLicense
    defaultEngineSettingName
    defaultEngineSettingVersion
    preloadDatasets {
      viewDatasetTransform
      paramsJSON
    }
  }
}
    `;
export type StoreMyViewForPreloadMutationFn = Apollo.MutationFunction<StoreMyViewForPreloadMutation, StoreMyViewForPreloadMutationVariables>;

/**
 * __useStoreMyViewForPreloadMutation__
 *
 * To run a mutation, you first call `useStoreMyViewForPreloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreMyViewForPreloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeMyViewForPreloadMutation, { data, loading, error }] = useStoreMyViewForPreloadMutation({
 *   variables: {
 *      datasetName: // value for 'datasetName'
 *      transformId: // value for 'transformId'
 *      paramsJSON: // value for 'paramsJSON'
 *      pinName: // value for 'pinName'
 *      setAsDefault: // value for 'setAsDefault'
 *      oldPinName: // value for 'oldPinName'
 *      deletePinName: // value for 'deletePinName'
 *   },
 * });
 */
export function useStoreMyViewForPreloadMutation(baseOptions?: Apollo.MutationHookOptions<StoreMyViewForPreloadMutation, StoreMyViewForPreloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreMyViewForPreloadMutation, StoreMyViewForPreloadMutationVariables>(StoreMyViewForPreloadDocument, options);
      }
export type StoreMyViewForPreloadMutationHookResult = ReturnType<typeof useStoreMyViewForPreloadMutation>;
export type StoreMyViewForPreloadMutationResult = Apollo.MutationResult<StoreMyViewForPreloadMutation>;
export type StoreMyViewForPreloadMutationOptions = Apollo.BaseMutationOptions<StoreMyViewForPreloadMutation, StoreMyViewForPreloadMutationVariables>;
export const TriggerMyRunNextStepsDocument = gql`
    mutation TriggerMyRunNextSteps($runSettings: RunInput!) {
  triggerMyRunNextSteps(runSettings: $runSettings)
}
    `;
export type TriggerMyRunNextStepsMutationFn = Apollo.MutationFunction<TriggerMyRunNextStepsMutation, TriggerMyRunNextStepsMutationVariables>;

/**
 * __useTriggerMyRunNextStepsMutation__
 *
 * To run a mutation, you first call `useTriggerMyRunNextStepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerMyRunNextStepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerMyRunNextStepsMutation, { data, loading, error }] = useTriggerMyRunNextStepsMutation({
 *   variables: {
 *      runSettings: // value for 'runSettings'
 *   },
 * });
 */
export function useTriggerMyRunNextStepsMutation(baseOptions?: Apollo.MutationHookOptions<TriggerMyRunNextStepsMutation, TriggerMyRunNextStepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerMyRunNextStepsMutation, TriggerMyRunNextStepsMutationVariables>(TriggerMyRunNextStepsDocument, options);
      }
export type TriggerMyRunNextStepsMutationHookResult = ReturnType<typeof useTriggerMyRunNextStepsMutation>;
export type TriggerMyRunNextStepsMutationResult = Apollo.MutationResult<TriggerMyRunNextStepsMutation>;
export type TriggerMyRunNextStepsMutationOptions = Apollo.BaseMutationOptions<TriggerMyRunNextStepsMutation, TriggerMyRunNextStepsMutationVariables>;
export const UnlockForecastFromDefaultSettingsDocument = gql`
    mutation UnlockForecastFromDefaultSettings {
  unlockForecastFromDefaultSettings {
    defaultEngineSettingName
    defaultEngineSettingVersion
    forecastLockedToRunId
  }
}
    `;
export type UnlockForecastFromDefaultSettingsMutationFn = Apollo.MutationFunction<UnlockForecastFromDefaultSettingsMutation, UnlockForecastFromDefaultSettingsMutationVariables>;

/**
 * __useUnlockForecastFromDefaultSettingsMutation__
 *
 * To run a mutation, you first call `useUnlockForecastFromDefaultSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockForecastFromDefaultSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockForecastFromDefaultSettingsMutation, { data, loading, error }] = useUnlockForecastFromDefaultSettingsMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnlockForecastFromDefaultSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UnlockForecastFromDefaultSettingsMutation, UnlockForecastFromDefaultSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockForecastFromDefaultSettingsMutation, UnlockForecastFromDefaultSettingsMutationVariables>(UnlockForecastFromDefaultSettingsDocument, options);
      }
export type UnlockForecastFromDefaultSettingsMutationHookResult = ReturnType<typeof useUnlockForecastFromDefaultSettingsMutation>;
export type UnlockForecastFromDefaultSettingsMutationResult = Apollo.MutationResult<UnlockForecastFromDefaultSettingsMutation>;
export type UnlockForecastFromDefaultSettingsMutationOptions = Apollo.BaseMutationOptions<UnlockForecastFromDefaultSettingsMutation, UnlockForecastFromDefaultSettingsMutationVariables>;
export const UploadAndTriggerMyRunDocument = gql`
    mutation UploadAndTriggerMyRun($fileContent: String!, $filename: String!, $runSettings: MyRunSettingsInput!, $runName: String) {
  uploadFinalLayerAndStartMyRun(
    fileContent: $fileContent
    filename: $filename
    editedRunSettings: $runSettings
    runName: $runName
  ) {
    success
    s3Key
    message
    runId
  }
}
    `;
export type UploadAndTriggerMyRunMutationFn = Apollo.MutationFunction<UploadAndTriggerMyRunMutation, UploadAndTriggerMyRunMutationVariables>;

/**
 * __useUploadAndTriggerMyRunMutation__
 *
 * To run a mutation, you first call `useUploadAndTriggerMyRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAndTriggerMyRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAndTriggerMyRunMutation, { data, loading, error }] = useUploadAndTriggerMyRunMutation({
 *   variables: {
 *      fileContent: // value for 'fileContent'
 *      filename: // value for 'filename'
 *      runSettings: // value for 'runSettings'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useUploadAndTriggerMyRunMutation(baseOptions?: Apollo.MutationHookOptions<UploadAndTriggerMyRunMutation, UploadAndTriggerMyRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAndTriggerMyRunMutation, UploadAndTriggerMyRunMutationVariables>(UploadAndTriggerMyRunDocument, options);
      }
export type UploadAndTriggerMyRunMutationHookResult = ReturnType<typeof useUploadAndTriggerMyRunMutation>;
export type UploadAndTriggerMyRunMutationResult = Apollo.MutationResult<UploadAndTriggerMyRunMutation>;
export type UploadAndTriggerMyRunMutationOptions = Apollo.BaseMutationOptions<UploadAndTriggerMyRunMutation, UploadAndTriggerMyRunMutationVariables>;
export const WhoAmIDocument = gql`
    query WhoAmI {
  whoAmI {
    id
    name
    email
    picture
    phoneNumber
    role
    customerId
  }
}
    `;

/**
 * __useWhoAmIQuery__
 *
 * To run a query within a React component, call `useWhoAmIQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoAmIQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoAmIQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoAmIQuery(baseOptions?: Apollo.QueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
      }
export function useWhoAmILazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export function useWhoAmISuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export type WhoAmIQueryHookResult = ReturnType<typeof useWhoAmIQuery>;
export type WhoAmILazyQueryHookResult = ReturnType<typeof useWhoAmILazyQuery>;
export type WhoAmISuspenseQueryHookResult = ReturnType<typeof useWhoAmISuspenseQuery>;
export type WhoAmIQueryResult = Apollo.QueryResult<WhoAmIQuery, WhoAmIQueryVariables>;
export const namedOperations = {
  Query: {
    GetAllCustomers: 'GetAllCustomers',
    GetAllMyEngineSettings: 'GetAllMyEngineSettings',
    GetCustomer: 'GetCustomer',
    GetLatestRuns: 'GetLatestRuns',
    GetMyCustomer: 'GetMyCustomer',
    GetMyDataFileDownloadUrl: 'GetMyDataFileDownloadUrl',
    GetMyDataFileOverrideUploadUrl: 'GetMyDataFileOverrideUploadUrl',
    GetMyDataFileWithOverrideDownloadUrl: 'GetMyDataFileWithOverrideDownloadUrl',
    GetMyEditedLayer: 'GetMyEditedLayer',
    GetMyEngineSettings: 'GetMyEngineSettings',
    GetMyInputDatastructureNames: 'GetMyInputDatastructureNames',
    getMyInputIds: 'getMyInputIds',
    GetMyOutputDatastructureNames: 'GetMyOutputDatastructureNames',
    GetMyRunComparisonSummary: 'GetMyRunComparisonSummary',
    GetMyRuns: 'GetMyRuns',
    GetMyTeamMembers: 'GetMyTeamMembers',
    WhoAmI: 'WhoAmI'
  },
  Mutation: {
    CreateMyEmailDomain: 'CreateMyEmailDomain',
    DeleteMyEmailDomain: 'DeleteMyEmailDomain',
    InviteMyTeamMember: 'InviteMyTeamMember',
    RemoveMyTeamMember: 'RemoveMyTeamMember',
    SetMyTeamMemberTemporaryPassword: 'SetMyTeamMemberTemporaryPassword',
    CancelMyRun: 'CancelMyRun',
    CopyForecastToDefaultSettings: 'CopyForecastToDefaultSettings',
    CreateCustomer: 'CreateCustomer',
    CreateCustomerEmailDomain: 'CreateCustomerEmailDomain',
    createOrReplaceFeatureFlags: 'createOrReplaceFeatureFlags',
    DeleteCustomerEmailDomain: 'DeleteCustomerEmailDomain',
    ExecuteMyLayerChangeSet: 'ExecuteMyLayerChangeSet',
    MakeMyEngineSettingsDefault: 'MakeMyEngineSettingsDefault',
    RerunMyStep: 'RerunMyStep',
    RetryMyRun: 'RetryMyRun',
    SaveApprovedPOs: 'SaveApprovedPOs',
    SaveApprovedPOsBatch: 'SaveApprovedPOsBatch',
    SavePurchasingCalendarOverrideToDefaultSettings: 'SavePurchasingCalendarOverrideToDefaultSettings',
    SetMyRunDescription: 'SetMyRunDescription',
    SetMyRunName: 'SetMyRunName',
    StartMyRecalculatedUserRun: 'StartMyRecalculatedUserRun',
    StartMyRun: 'StartMyRun',
    StartMySheetImporterSync: 'StartMySheetImporterSync',
    StartMyUserRun: 'StartMyUserRun',
    StoreMyEditedLayerAsSettings: 'StoreMyEditedLayerAsSettings',
    StoreMyViewForPreload: 'StoreMyViewForPreload',
    TriggerMyRunNextSteps: 'TriggerMyRunNextSteps',
    UnlockForecastFromDefaultSettings: 'UnlockForecastFromDefaultSettings',
    UploadAndTriggerMyRun: 'UploadAndTriggerMyRun'
  }
}